import React, { useState } from "react";
import "./email.css";

const EMAILS = {
    "select school for email" : null,
    "Abilene Christian University": "info@admissions.acu.edu",
    "Academy Of Art University": "admissions@academyart.edu",
    "Acadia University": "admissions@acadiau.ca",
    "Adams State University": "admissions@adams.edu",
    "Adelphi University": "admissions@adelphi.edu",
    "Adrian College": "admissions@adrian.edu",
    "Agnes Scott College": "admission@agnesscott.edu",
    "Alabama Agricultural And Mechanical University": "admissions@aamu.edu",
    "Alabama State University": "admissions@alasu.edu",
    "Alaska Bible College": "info@akbible.edu",
    "Alaska Pacific University": "admissions@alaskapacific.edu",
    "Albany College Pharmacy And Health Sciences": "admissions@acphs.edu",
    "Albany State University": "admissions@asurams.edu",
    "Albertus Magnus College": "admissions@albertus.edu",
    "Albion College": "admission@albion.edu",
    "Albright College": "admission@alb.edu",
    "Alcorn State University": "ksampson@alcorn.edu",
    "Alderson Broaddus University": "admissionsab.edu",
    "Alfred University": "admissions@alfred.edu",
    "Alice Lloyd College": "admissions@alc.edu",
    "Allegheny College": "admissions@allegheny.edu",
    "Allen College": "admissions@allencollege.edu",
    "Allen University": "admissions@allenuniversity.edu",
    "Alma College": "admissions@alma.edu",
    "Alvernia University": "admissions@alvernia.edu",
    "Alverno College": "admissions@alverno.edu",
    "American Baptist College": "atrice@abcnash.edu",
    "American International College": "admissions@aic.edu",
    "American Jewish University": "admissions@aju.edu",
    "American University": "admissions@american.edu",
    "American University Beirut Aub": "admissions@aub.edu.lb",
    "American University Bulgaria": "admissions@aubg.edu",
    "American University Paris": "admissions @aup.edu",
    "American University Rome": "admissions @aur.edu",
    "Amherst College": "admission @amherst.edu",
    "Anderson University": "info@anderson.edu",
    "Andrews University": "enroll@andrews.edu",
    "Angelo State University": "	admissions @angelo.edu",
    "Anna Maria College": "	admission@annamaria.edu",
    "Antioch College": "	admission@antiochcollege.edu",
    "Appalachian Bible College": "admissions@abc.edu",
    "Appalachian State University": "admissions@appstate.edu",
    "Aquinas College": "admissions@aquinas.edu",
    "Aquinas College Nashville": "admissions@aquinascollege.edu",
    "Arcadia University": "admiss@arcadia.edu",
    "Arizona Christian University": "admissions@arizonachristian.edu",
    "Arizona State University": "admissions@asu.edu",
    "Arkansas Baptist College": "admissions@arkansasbaptist.edu",
    "Arkansas State University": "admissions@astate.edu",
    "Arkansas Tech University": "tech.enroll@atu.edu",
    "Arlington Baptist University": "kmarvin@arlingtonbaptistcollege.edu",
    "Art Academy Cincinnati": "admissions@artacademy.edu",
    "Art Center College Of Design": "admissions@artcenter.edu",
    "Arts University Bournemouth Uk": "admissions@aub.ac.uk",
    "Asbury University": "admissions@asbury.edu",
    "Ashland University": "enrollme@ashland.edu",
    "Assumption College": "admiss@assumption.edu",
    "Athens State University": "admissions@athens.edu",
    "Auburn University": "admissions@auburn.edu",
    "Auburn University At Montgomery": "admissions@aum.edu",
    "Augsburg University": "admissions@augsburg.edu",
    "Augusta University": "admissions@augusta.edu",
    "Augustana College Illinois": "admissions@augustana.edu",
    "Augustana University South Dakota": "admission@augie.edu",
    "Aurora University": "admission@aurora.edu",
    "Austin College": "admission@austincollege.edu",
    "Austin Graduate School Of Theology": "admissions@austingrad.edu",
    "Austin Peay State University": "admissions@apsu.edu",
    "Ave Maria University": "admissions@avemaria.edu",
    "Averett University": "admit@averett.edu",
    "Avila University": "admissions @avila.edu",
    "Azusa Pacific University": "admissions@apu.edu",
    "Babson College": "ugradadmission@babson.edu",
    "Baker University": "admission@bakeru.edu",
    "Baldwin Wallace University": "admission@bw.edu",
    "Ball State University": "askus@bsu.edu",
    "Baptist College Of Florida": "admissions@baptistcollege.edu",
    "Baptist College Of Health Sciences": "admissions@bchs.edu",
    "Barclay College": "admissions@barclaycollege.edu",
    "Bard College": "admission@bard.edu",
    "Bard College Berlin": "admissions @berlin.bard.edu",
    "Bard College Simons Rock Early College": "admit@simons-rock.edu",
    "Barnard College": "admissions@barnard.edu",
    "Barry University": "admissions@barry.edu",
    "Barton College": "enroll@barton.edu",
    "Bastyr University": "admissions@bastyr.edu",
    "Bates College": "admission@bates.edu",
    "Bath Spa University": "internationaladmissions@bathspa.ac.uk",
    "Bay Path University": "admiss@baypath.edu",
    "Baylor University": "admissions@baylor.edu",
    "Beacon College": "admissions@beaconcollege.edu",
    "Becker College": "admissions@becker.edu",
    "Belhaven University": "admission@belhaven.edu",
    "Bellarmine University": "admissions@bellarmine.edu",
    "Belmont Abbey College": "admissions@bac.edu",
    "Belmont University": "admissions@belmont.edu",
    "Beloit College": "admiss@beloit.edu",
    "Bemidji State University": "admissions@bemidjistate.edu",
    "Benedict College": "admissions@benedict.edu",
    "Benedictine College": "bcadmiss@benedictine.edu",
    "Benedictine University Az": "mesa@ben.edu",
    "Benedictine University Il": "admissions @ben.edu",
    "Bennett College": "admiss@bennett.edu",
    "Bennington College": "admissions@bennington.edu",
    "Bentley University": "ugadmission@bentley.edu",
    "Berea College": "admissions@berea.edu",
    "Berklee College Of Music": "admissions@berklee.edu",
    "Berry College": "admissions@berry.edu",
    "Bethany College WV": "enrollment@bethanywv.edu",
    "Bethany College": "admissions@bethanylb.edu",
    "Bethany Lutheran College": "admissions@blc.edu",
    "Bethel College Kansas": "admissions@bethelks.edu",
    "Bethel University": "admissions@bethelu.edu",
    "Bethune Cookman University": "admissions@cookman.edu",
    "Beulah Heights University": "admissions@beulah.edu",
    "Biola University": "admissions@biola.edu",
    "Birmingham Southern College": "admission@bsc.edu",
    "Bishops University": "admissions@ubishops.ca",
    "Black Hills State University": "admissions@bhsu.edu",
    "Blackburn College": "admit@blackburn.edu",
    "Blessing Rieman College Of Nursing": "admissions@brcn.edu",
    "Bloomfield College": "admission@bloomfield.edu",
    "Bloomsburg University Of Pennsylvania": "buadmiss@bloomu.edu",
    "Blue Mountain College": "admissions@bmc.edu",
    "Bluefield College": "admissions@bluefield.edu",
    "Bluefield State College": "jschlimmer@bluefieldstate.edu",
    "Bluffton University": "admissions@bluffton.edu",
    "Bob Jones University": "admission@bju.edu",
    "Boise State University": "admissions@boisestate.edu",
    "Boston College": "bcapplicant@bc.edu",
    "Boston University": "admissions@bu.edu",
    "Bournemouth University Uk": "international@bournemouth.ac.uk",
    "Bowdoin College": "admissions@bowdoin.edu",
    "Bowie State University": "ugradadmissions@bowiestate.edu",
    "Bowling Green State University": "choosebgsu@bgsu.edu",
    "Bradley University": "admissions@bradley.edu",
    "Brandeis University": "admissions@brandeis.edu",
    "Brenau University": "admissions@brenau.edu",
    "Brescia University": "admissions@brescia.edu",
    "Brevard College": "admissions@brevard.edu",
    "Brewton Parker College": "admissions@bpc.edu",
    "Briar Cliff University": "admissions@briarcliff.edu",
    "Bridgewater College": "admissions@bridgewater.edu",
    "Bridgewater State University": "admission@bridgew.edu",
    "Brigham Young University Hawaii": "admissions@byuh.edu",
    "Brigham Young University Idaho": "admissions@byui.edu",
    "Brigham Young University Provo": "admissions@byu.edu",
    "Brown University": "admission_undergraduate@brown.edu",
    "Brunel University London": "international-admissions@brunel.ac.uk",
    "Bryan College": "admiss@bryan.edu",
    "Bryant University": "admission@bryant.edu",
    "Bryn Athyn College": "admissions@brynathyn.edu",
    "Bryn Mawr College": "admissions@brynmawr.edu",
    "Bucknell University": "admissions@bucknell.edu",
    "Buena Vista University": "admissions@bvu.edu",
    "Butler University": "admission@butler.edu",
    "Cabarrus College Of Health Sciences": "admissions@cabarruscollege.edu",
    "Cabrini University": "admit@cabrini.edu",
    "Cairn University": "admissions@cairn.edu",
    "Caldwell University": "admissions@caldwell.edu",
    "California Baptist University": "admissions@calbaptist.edu",
    "California College Arts": "admissions@cca.edu",
    "California College Of The Arts": "enroll@cca.edu",
    "California Institute Of The Arts": "admissions@calarts.edu",
    "California Institute Technology Caltech": "ugadmissions@caltech.edu",
    "California Lutheran University": "admissions@callutheran.edu",
    "California Maritime Academy": "admissions@csum.edu",
    "California State Polytechnic University Pomona": "admissions@cpp.edu",
    "California State University Bakersfield": "admissions@csub.edu",
    "California State University Chico": "info@csuchico.edu",
    "California State University Dominguez Hills": "info@csudh.edu",
    "California State University East Bay": "admissions@csueastbay.edu",
    "California State University Fresno": "admissions@csufresno.edu",
    "California State University Fullerton": "admissions@fullerton.edu",
    "California State University Long Beach": "eslb@csulb.edu",
    "California State University Los Angeles": "admission@calstatela.edu",
    "California State University Monterey Bay": "admissions@csumb.edu",
    "California State University Northridge": "admissions.records@csun.edu",
    "California State University Sacramento": "admissions@csus.edu",
    "California State University San Bernardino": "moreinfo@csusb.edu",
    "California State University San Marcos": "apply@csusm.edu",
    "California State University Stanislaus": "outreach_help_desk@csustan.edu",
    "California University Of Pennsylvania": "inquiry@calu.edu",
    "California University Pennsylvania": "admissions@calu.edu",
    "Calumet College Of St Joseph": "admissions@ccsj.edu",
    "Calvary University": "admissions@calvary.edu",
    "Calvin College": "admissions@calvin.edu",
    "Cambridge College": "admissions@cambridgecollege.edu",
    "Cameron University": "admissions@cameron.edu",
    "Campbellsville University": "admissions@campbellsville.edu",
    "Canisius College": "admissions@canisius.edu",
    "Capital University": "admission@capital.edu",
    "Capitol Technology University": "admissions@captechu.edu",
    "Cardinal Stritch University": "admissions@stritch.edu",
    "Caribbean University": "admisiones@caribbean.edu",
    "Carleton College": "admissions@carleton.edu",
    "Carlow University": "admissions@carlow.edu",
    "Carroll College": "enroll@carroll.edu",
    "Carroll College Montana": "admission@carroll.edu",
    "Carroll University": "info@carrollu.edu",
    "Carson Newman University": "admitme@cn.edu",
    "Carthage College": "admissions@carthage.edu",
    "Case Western Reserve University": "admission@case.edu",
    "Castleton University": "info@castleton.edu",
    "Catawba College": "admissions@catawba.edu",
    "Catholic University America": "cua-admissions@cua.edu",
    "Cazenovia College": "admission@cazenovia.edu",
    "Cedar Crest College": "admissions@cedarcrest.edu",
    "Cedarville University": "admiss@cedarville.edu",
    "Centenary College Louisiana": "admission@centenary.edu",
    "Centenary University": "admissions@centenaryuniversity.edu",
    "Central Christian College Of Kansas": "admissions@centralchristian.edu",
    "Central College": "admission@central.edu",
    "Central Connecticut State University": "admissions@ccsu.edu",
    "Central Methodist University": "admissions@centralmethodist.edu",
    "Central Michigan University": "cmuadmit@cmich.edu",
    "Central Penn College": "admissions@centralpenn.edu",
    "Central State University": "admissions@centralstate.edu",
    "Central Washington University": "admissions@cwu.edu",
    "Centre College": "admission@centre.edu",
    "Chadron State College": "cscadmissions@csc.edu",
    "Chaminade University Honolulu": "admissions@chaminade.edu",
    "Champlain College": "admission@champlain.edu",
    "Chapman University": "admit@chapman.edu",
    "Charles R Drew University Medicine And Science": "admissionsinfo@cdrewu.edu",
    "Charleston Southern University": "enroll@csuniv.edu",
    "Charter Oak State College": "admissions@charteroak.edu",
    "Chatham University": "admissions@chatham.edu",
    "Chestnut Hill College": "admissions@chc.edu",
    "Cheyney University Of Pennsylvania": "admissions@cheyney.edu",
    "Chicago State University": "ug-admissions@csu.edu",
    "Chipola College": "hambrightb@chipola.edu",
    "Chowan University": "enroll@chowan.edu",
    "Christendom College": "admissions@christendom.edu",
    "Christian Brothers University": "admissions@cbu.edu",
    "Christopher Newport University": "admit@cnu.edu",
    "Cincinnati Christian University": "ccuadmissions@ccuniversity.edu",
    "Claflin University": "admissions@claflin.edu",
    "Claremont Mckenna College": "admission@cmc.edu",
    "Clarion University Of Pennsylvania": "admissions@clarion.edu",
    "Clark Atlanta University": "admissions@cau.edu",
    "Clark University": "admissions@clarku.edu",
    "Clarke University": "admissions@clarke.edu",
    "Clarks Summit University": "admissions@clarkssummitu.edu",
    "Clarkson College": "admissions@clarksoncollege.edu",
    "Clarkson University": "admission@clarkson.edu",
    "Clayton State University": "ccsu-info@clayton.edu",
    "Clear Creek Baptist Bible College": "admissions@ccbbc.edu",
    "Cleary University": "admissions@cleary.edu",
    "Clemson University": "cuadmissions@clemson.edu",
    "Cleveland Institute Of Music": "admission@cim.edu",
    "Cleveland State University": "admissions@csuohio.edu",
    "Coastal Carolina University": "admissions@coastal.edu",
    "Coe College": "admission@coe.edu",
    "Cogswell Polytechnical College": "info@cogswell.edu",
    "Coker College": "admissions@coker.edu",
    "Colby College": "admissions@colby.edu",
    "Colby Sawyer College": "admissions@colby-sawyer.edu",
    "Colgate University": "admission@colgate.edu",
    "College Of Charleston": "admissions@cofc.edu",
    "College of Idaho": "admission@collegeofidaho.edu",
    "College of Mount Saint Vincent": "admissions@mountsaintvincent.edu",
    "College Of Mount St Vincent": "admissions.office@mountsaintvincent.edu",
    "College of New Jersey": "tcnjinfo@tcnj.edu",
    "College of New Rochelle": "admission@cnr.edu",
    "College Of Saint Benedict": "admissions@csbsju.edu",
    "College of Saint Elizabeth": "apply@cse.edu",
    "College of Saint Rose": "admit@strose.edu",
    "College Of St Mary": "enroll@csm.edu",
    "College Of Staten Island Cuny": "admissions@csi.cuny.edu",
    "College of the Atlantic Atlantic": "inquiry@coa.edu",
    "College of the Holy Cross": "admissions@holycross.edu",
    "College Of The Ozarks": "admissions@cofo.edu",
    "College of William & Mary": "admission@wm.edu",
    "College St Joseph": "admissions@csj.edu",
    "College St Scholastica": "admissions@css.edu",
    "College Wooster": "admissions@wooster.edu",
    "Colorado Christian University": "ccuadmissions@ccu.edu",
    "Colorado College": "admission@coloradocollege.edu",
    "Colorado Mesa University": "admissions@coloradomesa.edu",
    "Colorado School Of Mines": "admit@mines.edu",
    "Colorado State University": "admissions@colostate.edu",
    "Colorado State University Pueblo": "info@csupueblo.edu",
    "Columbia College": "admissions@ccis.edu",
    "Columbia College SC": "admissions@columbiasc.edu",
    "Columbia College Chicago": "admissions@colum.edu",
    "Columbia College Hollywood": "admissions@columbiacollege.edu",
    "Columbia International University": "yesciu@ciu.edu",
    "Columbus College Of Art And Design": "admissions@ccad.edu",
    "Columbus State University": "admissions@columbusstate.edu",
    "Concord University": "admissions@concord.edu",
    "Concordia College": "admission @concordia-ny.edu",
    "Concordia College Moorhead": "admissions@cord.edu",
    "Concordia University Chicago": "Admission@CUChicago.edu",
    "Concordia University Irvine": "admissions@cui.edu",
    "Concordia University Nebraska": "admiss@cune.edu",
    "Concordia University Portland Or": "admission@cu-portland.edu",
    "Concordia University St Paul": "admissions@csp.edu",
    "Concordia University Texas": "admissions@concordia.edu",
    "Concordia University Wisconsin": "admissions@cuw.edu",
    "Connecticut College": "admission@conncoll.edu",
    "Conservatory Of Music Of Puerto Rico": "admisiones@cmpr.edu",
    "Converse College": "admissions@converse.edu",
    "Cooper Union Advancement Science And Art": "admissions@cooper.edu",
    "Coppin State University": "admissions@coppin.edu",
    "Corban University": "admissions@corban.edu",
    "Cornell College": "admission@cornellcollege.edu",
    "Cornerstone University": "admissions@cornerstone.edu",
    "Cornish College Of The Arts": "admission@cornish.edu",
    "Covenant College": "admissions@covenant.edu",
    "Creighton University": "admissions@creighton.edu",
    "Criswell College": "enrollment@criswell.edu",
    "Crown College": "admissions@crown.edu",
    "Culinary Institute America Ny": "admissions@culinary.edu",
    "Culver Stockton College": "admission@culver.edu",
    "Cumberland University": "admissions@cumberland.edu",
    "Cuny Baruch College": "admissions@baruch.cuny.edu",
    "Cuny City College": "admissions@ccny.cuny.edu",
    "Cuny Hunter College": "admissions@hunter.cuny.edu",
    "Cuny John Jay College Of Criminal Justice": "admissions@jjay.cuny.edu",
    "Cuny Lehman College": "enroll@lehman.cuny.edu",
    "Cuny Medgar Evers College": "applytomec@mec.cuny.edu",
    "Cuny New York City College Of Technology": "admissions@citytech.cuny.edu",
    "Cuny Queens College": "admissions@qc.cuny.edu",
    "Cuny York College": "admissions@york.cuny.edu",
    "Curry College": "adm@curry.edu",
    "Daemen College": "admissions@daemen.edu",
    "Dakota State University": "admissions@dsu.edu",
    "Dakota Wesleyan University": "admissions@dwu.edu",
    "Dallas Baptist University": "admiss@dbu.edu",
    "Dallas Christian College": "admissions@dallas.edu",
    "Dalton State College": "admissions@daltonstate.edu",
    "Dartmouth College": "admissions.office@dartmouth.edu",
    "Davenport University": "info@davenport.edu",
    "Davidson College": "admission@davidson.edu",
    "Davis Elkins College": "summersm@dewv.edu",
    "Dean College": "admissions@dean.edu",
    "Defiance College": "admissions@defiance.edu",
    "Delaware State University": "admissions@desu.edu",
    "Delaware Valley University": "admitme@delval.edu",
    "Delta State University": "admissions@deltastate.edu",
    "Denison University": "admissions@denison.edu",
    "Depaul University": "admission@depaul.edu",
    "Depauw University": "admission@depauw.edu",
    "Desales University": "admiss@desales.edu",
    "Dickinson College": "admissions@dickinson.edu",
    "Dickinson State University": "dsu.hawks@dickinsonstate.edu",
    "Digipen Institute Of Technology": "admissions@digipen.edu",
    "Dillard University": "admissions@dillard.edu",
    "Dixie State University": "admissions@dixie.edu",
    "Doane University": "admissions@doane.edu",
    "Dominican College": "admissions@dc.edu",
    "Dominican University": "domadmis@dom.edu",
    "Dominican University California": "enroll@dominican.edu",
    "Dordt College": "admissions@dordt.edu",
    "Doshisha University Institute Liberal Arts": "ji-ila@mail.doshisha.ac.jp",
    "Drake University": "admission @drake.edu",
    "Drew University": "cadm@drew.edu",
    "Drexel University": "enroll@drexel.edu",
    "Drury University": "druryad@drury.edu",
    "Duke Kunshan University": "undergrad-admissions@dukekunshan.edu.cn",
    "Duke University": "undergrad-admissions@duke.edu",
    "Duquesne University": "admissions@duq.edu",
    "Durham University": "study@durham.ac.uk",
    "Dyouville College": "admissons@dyc.edu",
    "Earlham College": "admissions@earlham.edu",
    "East Carolina University": "admis@ecu.edu",
    "East Central University": "admissions@ecok.edu",
    "East Stroudsburg University Of Pennsylvania": "undergrads@esu.edu",
    "East Tennessee State University": "go2etsu@etsu.edu",
    "East Texas Baptist University": "admissions@etbu.edu",
    "East West University": "admissions@eastwest.edu",
    "Eastern Connecticut State University": "admissions@easternct.edu",
    "Eastern Illinois University": "admissions@eiu.edu",
    "Eastern Kentucky University": "admissions@eku.edu",
    "Eastern Mennonite University": "admiss@emu.edu",
    "Eastern Michigan University": "admissions@emich.edu",
    "Eastern Nazarene College": "admissions@enc.edu",
    "Eastern New Mexico University": "enrollment.services@enmu.edu",
    "Eastern Oregon University": "admissions@eou.edu",
    "Eastern University": "ugadm@eastern.edu",
    "Eastern Washington University": "admissions@ewu.edu",
    "Eckerd College": "admissions@eckerd.edu",
    "Edgewood College": "admissions@edgewood.edu",
    "Edinboro University Pennsylvania": "admissions@edinboro.edu",
    "Edward Waters College": "admissions@ewc.edu",
    "Elizabeth City State University": "admissions@ecsu.edu",
    "Elizabethtown College": "admissions@etown.edu",
    "Elmhurst College": "admit@elmhurst.edu",
    "Elmira College": "admissions@elmira.edu",
    "Elms College": "admissions@elms.edu",
    "Elon University": "admissions@elon.edu",
    "Embry Riddle Aeronautical University Daytona Beach": "dbadmit@erau.edu",
    "Embry Riddle Aeronautical University Prescott": "pradmit@erau.edu",
    "Embry Riddle Aeronautical University Worldwide Campus": "wwadmissions@erau.edu",
    "Emerson College": "admission@emerson.edu",
    "Emily Carr University Of Art Design": "admissions@ecuad.ca",
    "Emmanuel College": "enroll@emmanuel.edu",
    "Emmanuel College Ga": "admissions@ec.edu",
    "Emmanuel College Ma": "admissions@emmanuel.edu",
    "Emmaus Bible College": "admissions@emmaus.edu",
    "Emory Henry College": "ehadmiss@ehc.edu",
    "Emory University": "admission@emory.edu",
    "Emporia State University": "go2esu@emporia.edu",
    "Endicott College": "admission@endicott.edu",
    "Erskine College": "admissions@erskine.edu",
    "Escp Europe Business School": "bachelorlondon@escpeurope.eu",
    "Eugene Lang College The New School For Liberal Arts": "lang@newschool.edu",
    "Eureka College": "admissions@eureka.edu",
    "Evangel University": "admissions@evangel.edu",
    "Evergreen State College": "admissions@evergreen.edu",
    "Fairfield University": "admis@fairfield.edu",
    "Fairleigh Dickinson University": "admissions@fdu.edu",
    "Fairmont State University": "admit@fairmontstate.edu",
    "Faith Baptist Bible College And Theological Seminary": "admissions@faith.edu",
    "Fashion Institute Of Technology": "fitinfo@fitnyc.edu",
    "Faulkner University": "admissions@faulkner.edu",
    "Fayetteville State University": "admissions@uncfsu.edu",
    "Felician University": "admissions@felician.edu",
    "Ferris State University": "admissions@ferris.edu",
    "Ferrum College": "admissions@ferrum.edu",
    "Fisher College": "admissions@fisher.edu",
    "Fisk University": "admit@fisk.edu",
    "Fitchburg State University": "admissions@fitchburgstate.edu",
    "Five Towns College": "admissions@ftc.edu",
    "Flagler College": "admissions@flagler.edu",
    "Flashpoint Chicago Campus Columbia College Hollywood": "flashpoint.admissions@columbiacollege.edu",
    "Florida Agricultural Mechanical University": "ugrdadmissions@famu.edu",
    "Florida Atlantic University": "admissions@fau.edu",
    "Florida College": "admissions@floridacollege.edu",
    "Florida Gulf Coast University": "admissions@fgcu.edu",
    "Florida Institute Technology": "admission@fit.edu",
    "Florida International University": "admiss@fiu.edu",
    "Florida Memorial University": "admit@fmuniv.edu",
    "Florida National University": "admissions@fnu.edu",
    "Florida Polytechnic University": "admissions@flpoly.org",
    "Florida Southern College": "fscadm@flsouthern.edu",
    "Florida State University": "admissions@fsu.edu",
    "Fontbonne University": "fbyou@fontbonne.edu",
    "Fordham University": "enroll@fordham.edu",
    "Fort Hays State University": "tigers@fhsu.edu",
    "Fort Lewis College": "admission@fortlewis.edu",
    "Fort Valley State University": "admissions@fvsu.edu",
    "Framingham State University": "admissions@framingham.edu",
    "Francis Marion University": "admissions@fmarion.edu",
    "Franciscan Missionaries Of Our Lady University": "ololcinfo@ololcollege.edu",
    "Franciscan University Of Steubenville": "admissions@franciscan.edu",
    "Franklin College": "admissions@franklincollege.edu",
    "Franklin Marshall College": "admission@fandm.edu",
    "Franklin Pierce University": "admissions@franklinpierce.edu",
    "Franklin University Switzerland": "info@fus.edu",
    "Franklin W Olin College Engineering": "apply@olin.edu",
    "Freed Hardeman University": "admissions@fhu.edu",
    "Fresno Pacific University": "admissions@fresno.edu",
    "Friends University": "admission@friends.edu",
    "Frostburg State University": "fsuadmissions@frostburg.edu",
    "Furman University": "admission@furman.edu",
    "Gallaudet University": "admissions.office@gallaudet.edu",
    "Gannon University": "admissions@gannon.edu",
    "Gardner Webb University": "admissions@gardner-webb.edu",
    "George Fox University": "admissions@georgefox.edu",
    "George Mason University": "admissions@gmu.edu",
    "George Washington University": "gwadm@gwu.edu",
    "Georgetown College": "admissions@georgetowncollege.edu",
    "Georgetown University": "guadmiss@georgetown.edu",
    "Georgia College": "admissions@gcsu.edu",
    "Georgia Gwinnett College": "ggcadmissions@ggc.edu",
    "Georgia Southern University Armstrong And Liberty Campuses": "admissions@georgiasouthern.edu",
    "Georgia Southwestern State University": "admissions@gsw.edu",
    "Georgia State University": "admissions@gsu.edu",
    "Georgian Court University": "admissions@georgian.edu",
    "Gettysburg College": "admiss@gettysburg.edu",
    "Glenville State College": "admissions@glenville.edu",
    "Goddard College": "admissions@goddard.edu",
    "Goldey Beacom College": "gbc@gbc.edu",
    "Goldfarb School Of Nursing At Barnes Jewish College": "gson-admissions@bjc.org",
    "Gonzaga University": "admissions@gonzaga.edu",
    "Gordon College": "admissions@gordon.edu",
    "Gordon State College": "gordon@gordonstate.edu",
    "Goshen College": "admission@goshen.edu",
    "Goucher College": "admissions@goucher.edu",
    "Governors State University": "admissions@govst.edu",
    "Grace Bible College": "graceadmissions@gbcol.edu",
    "Grace College Seminary": "admissions@grace.edu",
    "Graceland University": "admissions@graceland.edu",
    "Grambling State University": "admissions@gram.edu",
    "Grand Canyon University": "facouns@gcu.edu",
    "Grand Valley State University": "go2gvsu@gvsu.edu",
    "Grand View University": "admissions@grandview.edu",
    "Granite State College": "ask.granite@granite.edu",
    "Great Basin College": "admissions@gbcnv.edu",
    "Green Mountain College": "admissions@greenmtn.edu",
    "Greensboro College": "admissions@greensboro.edu",
    "Greenville University": "admissions@greenville.edu",
    "Grinnell College": "admission@grinnell.edu",
    "Grove City College": "admissions@gcc.edu",
    "Guilford College": "admission@guilford.edu",
    "Gustavus Adolphus College": "admission@gustavus.edu",
    "Gwynedd Mercy University": "admissions@gmercyu.edu",
    "Hamilton College": "admission@hamilton.edu",
    "Hamline University Mn": "admission@hamline.edu",
    "Hampden Sydney College": "admissions@hsc.edu",
    "Hampshire College": "admissions@hampshire.edu",
    "Hampton University": "admit@hamptonu.edu",
    "Hannibal Lagrange University": "admissions@hlg.edu",
    "Hanover College": "admission@hanover.edu",
    "Hardin Simmons University": "enroll@hsutx.edu",
    "Harding University": "admissions@harding.edu",
    "Harris Stowe State University": "admissions@hssu.edu",
    "Harrisburg University Science And Technology": "UndergraduateAdmissions@HarrisburgU.edu",
    "Hartwick College": "admissions@hartwick.edu",
    "Harvard College": "college@fas.harvard.edu",
    "Harvey Mudd College": "admission@hmc.edu",
    "Hastings College": "hcadmissions@hastings.edu",
    "Haverford College": "admission@haverford.edu",
    "Hawaii Pacific University": "admissions@hpu.edu",
    "Heidelberg University": "admission@heidelberg.edu",
    "Hellenic College": "admissions@hchc.edu",
    "Henderson State University": "admissions@hsu.edu",
    "Hendrix College": "adm@hendrix.edu",
    "High Point University": "admiss@highpoint.edu",
    "Hilbert College": "admissions@hilbert.edu",
    "Hillsdale College": "admissions@hillsdale.edu",
    "Hiram College": "admission@hiram.edu",
    "Hobart And William Smith Colleges": "admissions@hws.edu",
    "Hodges University": "admit@hodges.edu",
    "Hofstra University": "admission@hofstra.edu",
    "Hollins University": "huadm@hollins.edu",
    "Holy Cross College": "admissions@hcc-nd.edu",
    "Holy Family University": "admissions@holyfamily.edu",
    "Holy Names University": "admissions@hnu.edu",
    "Hood College": "admissions@hood.edu",
    "Hope College": "admissions@hope.edu",
    "Houghton College": "admission@houghton.edu",
    "Houston Baptist University": "admissions@hbu.edu",
    "Howard Payne University": "enroll@hputx.edu",
    "Howard University": "admission@howard.edu",
    "Hult International Business School": "undergraduate.info@hult.edu",
    "Humboldt State University": "hsuinfo@humboldt.edu",
    "Huntingdon College": "admiss@hawks.huntingdon.edu",
    "Huntingdon College Of Health Sciences": "admissions@hchs.edu",
    "Huntington University": "admissions@huntington.edu",
    "Husson University": "admit@husson.edu",
    "Huston Tillotson University": "admission@htu.edu",
    "Idaho State University": "admiss@isu.edu",
    "Ie University": "university@ie.edu",
    "Illinois College": "admissions@mail.ic.edu",
    "Illinois Institute Technology": "admission@iit.edu",
    "Illinois State University": "admissions@illinoisstate.edu",
    "Illinois Wesleyan University": "iwuadmit@iwu.edu",
    "Immaculata University": "Admiss@immaculata.edu",
    "Indiana Institute Of Technology": "admissions@indianatech.edu",
    "Indiana State University": "admissions@indstate.edu",
    "Indiana University Bloomington": "iuadmit@indiana.edu",
    "Indiana University East": "applynow@iue.edu",
    "Indiana University Kokomo": "iuadmis@iuk.edu",
    "Indiana University Northwest": "admit@iun.edu",
    "Indiana University Of Pennsylvania": "admissions-inquiry@iup.edu",
    "Indiana University South Bend": "admissions@iusb.edu",
    "Indiana University Southeast": "admissions@ius.edu",
    "Indiana Wesleyan University": "admissions@indwes.edu",
    "Institute Of American Indian Arts": "admissions@iaia.edu",
    "Inter American University Of Puerto Rico Aguadilla": "gcortes@aguadilla.inter.edu",
    "Inter American University Of Puerto Rico Fajardo": "ada.caraballo@fajardo.inter.edu",
    "Inter American University Of Puerto Rico Guayama": "laura.ferrer@guayama.inter.edu",
    "Inter American University Of Puerto Rico Ponce": "admisiones@ponce.inter.edu",
    "Inter American University Of Puerto Rico San German": "milcama@intersg.edu",
    "Iona College": "admissions@iona.edu",
    "Iowa State University": "admissions@iastate.edu",
    "Iowa Wesleyan University": "admit@iw.edu",
    "IPFW": "ask@ipfw.edu",
    "Ithaca College": "admission@ithaca.edu",
    "IUPUI": "apply@iupui.edu",
    "Jackson State University": "admappl@jsums.edu",
    "Jacksonville State University": "info@jsu.edu",
    "Jacksonville University": "admissions@ju.edu",
    "Jacobs University Bremen": "admission@jacobs-university.de",
    "James Madison University": "admissions@jmu.edu",
    "Jarvis Christian College": "recruitment@jarvis.edu",
    "Jefferson College Health Sciences": "admissions@jchs.edu",
    "Jefferson Philadelphia University Thomas Jefferson University": "admissions@philau.edu",
    "John Brown University": "jbuinfo@jbu.edu",
    "John Cabot University Rome": "admissions@johncabot.edu",
    "John Carroll University": "enrollment@jcu.edu",
    "John Paul The Great Catholic University": "mharold@jpcatholic.com",
    "John Wesley University": "admissions@johnwesley.edu",
    "Johns Hopkins University": "gotojhu@jhu.edu",
    "Johnson C Smith University": "admissions@jcsu.edu",
    "Johnson University": "admissions@johnsonu.edu",
    "Johnson University Florida": "admissionsfl@johnsonu.edu",
    "Johnson Wales University": "mia@admissions.jwu.edu",
    "Johnson Wales University alt 1": "pvd@admissions.jwu.edu",
    "Johnson Wales University alt 2": "den@admissions.jwu.edu",
    "Johnson Wales University alt 3": "clt@admissions.jwu.edu",
    "Judson College": "admissions@judson.edu",
    "Judson University": "admissions@judsonu.edu",
    "Juilliard School": "admissions@juilliard.edu",
    "Juniata College": "admissions@juniata.edu",
    "Kalamazoo College": "admission@kzoo.edu",
    "Kansas City Art Institute": "admiss@kcai.edu",
    "Kansas State University": "k-state@k-state.edu",
    "Kean University": "admitme@kean.edu",
    "Keele University": "international@keele.ac.uk",
    "Keene State College": "kscadmissions@keene.edu",
    "Kendall College": "info@kendall.edu",
    "Kennesaw State University": "ksuadmit@kennesaw.edu",
    "Kent State University": "admissions@kent.edu",
    "Kentucky Christian University": "knights@kcu.edu",
    "Kentucky Mountain Bible College": "kmbc@kmbc.edu",
    "Kentucky State University": "admissions@kysu.edu",
    "Kentucky Wesleyan College": "admissions@kwc.edu",
    "Kenyon College": "admissions@kenyon.edu",
    "Kettering University": "admissions @kettering.edu",
    "Keuka College": "admissions@keuka.edu",
    "Keystone College": "admissions@keystone.edu",
    "King University": "admission@king.edu",
    "Kings College": "admissions@kings.edu",
    "Knox College": "admission@knox.edu",
    "Kutztown University Of Pennsylvania": "admissions@kutztown.edu",
    "Kuyper College": "admissions@kuyper.edu",
    "La Roche College": "admissions@laroche.edu",
    "La Salle University": "admiss@lasalle.edu",
    "La Sierra University": "admissions@lasierra.edu",
    "Lafayette College": "admissions@lafayette.edu",
    "Lagrange College": "admission@lagrange.edu",
    "Laguna College Of Art And Design": "admissions@lcad.edu",
    "Lake Erie College": "admissions@lec.edu",
    "Lake Forest College": "admissions@lakeforest.edu",
    "Lake Superior State University": "admissions@lssu.edu",
    "Lakeland University": "admissions@lakeland.edu",
    "Lamar University": "admissions@lamar.edu",
    "Lander University": "admissions@lander.edu",
    "Lane College": "admissions@lanecollege.edu",
    "Langston University": "admissions@langston.edu",
    "Lasell College": "info@lasell.edu",
    "Lawrence Technological University": "admissions@ltu.edu",
    "Lawrence University": "admissions@lawrence.edu",
    "Le Moyne College": "admission@lemoyne.edu",
    "Leavell College Of New Orleans Baptist Theological Seminary": "leavelladmissions@nobts.edu",
    "Lebanon Valley College": "admission@lvc.edu",
    "Lee University": "admissions@leeuniversity.edu",
    "Lees Mcrae College": "admissions@lmc.edu",
    "Lehigh University": "admissions@lehigh.edu",
    "Lemoyne Owen College": "admission@loc.edu",
    "Lenoir Rhyne University": "admission@lr.edu",
    "Lesley University": "admissions@lesley.edu",
    "Letourneau University": "admissions@letu.edu",
    "Lewis Clark College": "admissions@lclark.edu",
    "Lewis Clark State College": "admissions@lcsc.edu",
    "Lewis University": "admissions@lewisu.edu",
    "Liberty University": "admissions@liberty.edu",
    "Life Pacific College": "info@lifepacific.edu",
    "Life University": "admission@life.edu",
    "Lim College": "admissions@limcollege.edu",
    "Limestone College": "admiss@limestone.edu",
    "Lincoln Christian University": "enroll@lincolnchristian.edu",
    "Lincoln Memorial University": "admissions@lmunet.edu",
    "Lincoln University CA": "admissions@lincolnuca.edu",
    "Lincoln University PA": "admissions@lincoln.edu",
    "Lincoln University MO": "admissions@lincolnu.edu",
    "Lindenwood University": "Admissions@lindenwood.edu",
    "Lindsey Wilson College": "admissions@lindsey.edu",
    "Linfield College": "admission@linfield.edu",
    "Lipscomb University": "admissions@lipscomb.edu",
    "List College Jewish Theological Seminary": "lcadmissions@jtsa.edu",
    "Livingstone College": "admissions@livingstone.edu",
    "Lock Haven University Of Pennsylvania": "admissions@lockhaven.edu",
    "Long Island University Brooklyn Campus": "bkln-admissions@liu.edu",
    "Long Island University Post Campus": "post-enroll@liu.edu",
    "Longwood University": "admissions@longwood.edu",
    "Loras College": "admissions@loras.edu",
    "Louisiana College": "admissions@lacollege.edu",
    "Louisiana State University Am Baton Rouge": "admissions@lsu.edu",
    "Louisiana State University Shreveport": "admissions@lsus.edu",
    "Louisiana Tech University": "bulldog@latech.edu",
    "Lourdes University": "luadmits@lourdes.edu",
    "Loyola Marymount University": "admissions@lmu.edu",
    "Loyola University Chicago": "admission@luc.edu",
    "Loyola University Maryland": "admissions@loyola.edu",
    "Loyola University New Orleans": "admit@loyno.edu",
    "Lubbock Christian University": "admissions@lcu.edu",
    "Luther College": "admissions@luther.edu",
    "Luther Rice College Seminary": "admissions@lutherrice.edu",
    "Lycoming College": "admissions@lycoming.edu",
    "Lyme Academy College Of Fine Arts": "admissions@lymefs.newhaven.edu",
    "Lynn University": "admission@lynn.edu",
    "Lyon College": "admissions@lyon.edu",
    "Macalester College": "admissions@macalester.edu",
    "Macmurray College	": "admissions@mac.edu",
    "Madonna University": "admissions@madonna.edu",
    "Maharishi University Of Management": "admissions@mum.edu",
    "Maine College Art": "admissions@meca.edu",
    "Maine Maritime Academy": "admissions@mma.edu",
    "Malone University": "admissions@malone.edu",
    "Manchester University": "admitinfo@manchester.edu",
    "Manhattan Christian College": "admit@mccks.edu",
    "Manhattan College": "admit@manhattan.edu",
    "Manhattan School Of Music": "admission@msmnyc.edu",
    "Manhattanville College": "admissions@mville.edu",
    "Mansfield University Of Pennsylvania": "admissions@mansfield.edu",
    "Maranatha Baptist University": "admissions@mbu.edu",
    "Marian University Indiana": "admissions@marian.edu",
    "Marian University Wisconsin": "admissions@marianuniversity.edu",
    "Marietta College": "wardens@marietta.edu",
    "Marist College": "admission@marist.edu",
    "Marlboro College": "admissions@marlboro.edu",
    "Marquette University WI": "admissions@mu.edu",
    "Mars Hill University": "admissions@mhu.edu",
    "Marshall University": "admissions@marshall.edu",
    "Martin Luther College": "bauermd@mlc-wels.edu",
    "Martin Methodist College": "admit@martinmethodist.edu",
    "Martin University": "admissions@martin.edu",
    "Mary Baldwin University": "admit@marybaldwin.edu",
    "Mary Immaculate College": "international@mic.ul.ie",
    "Marygrove College": "info@marygrove.edu",
    "Maryland Institute College Art": "admissions@mica.edu",
    "Marylhurst University": "admissions@marylhurst.edu",
    "Marymount California University": "admission@marymountcalifornia.edu",
    "Marymount Manhattan College": "admissions@mmm.edu",
    "Marymount University": "admissions@marymount.edu",
    "Maryville College": "admissions@maryvillecollege.edu",
    "Maryville University St Louis": "admissions@maryville.edu",
    "Marywood University": "yourfuture@marywood.edu",
    "Massachusetts College Art And Design": "admissions@massart.edu",
    "Massachusetts College Liberal Arts": "admissions@mcla.edu",
    "Massachusetts College Pharmacy And Health Sciences Mcphs University": "admissions@mcphs.edu",
    "Massachusetts Institute Of Technology": "admissions@mit.edu",
    "Massachusetts Maritime Academy": "admissions@maritime.edu",
    "Maynooth University Ireland": "deirdre.a.dunne@mu.ie",
    "Mayville State University": "masu.admissions@mayvillestate.edu",
    "Mcdaniel College": "admissions@mcdaniel.edu",
    "Mckendree University": "inquiry@mckendree.edu",
    "Mcmurry University": "admissions@mcm.edu",
    "Mcneese State University": "admissions@mcneese.edu",
    "Mcpherson College": "admissions@mcpherson.edu",
    "Medaille College": "admissionsug@medaille.edu",
    "Medical University Of South Carolina": "oesadmis@musc.edu",
    "Memphis College Of Art": "info@mca.edu",
    "Menlo College": "admissions@menlo.edu",
    "Mercer University": "admissions@mercer.edu",
    "Mercy College": "admissions@mercy.edu",
    "Mercy College Of Health Sciences": "admissions@mchs.edu",
    "Mercyhurst University": "admissions@mercyhurst.edu",
    "Meredith College": "admissions@meredith.edu",
    "Merrimack College": "admission@merrimack.edu",
    "Messiah College": "admissions@messiah.edu",
    "Methodist University": "admissions@methodist.edu",
    "Metropolitan College Of New York": "admissions@mcny.edu",
    "Metropolitan State University": "admission.metro@metrostate.edu",
    "Metropolitan State University Of Denver": "askmetro@msudenver.edu",
    "Miami University Ohio": "admission@miamioh.edu",
    "Michigan State University": "admis@msu.edu",
    "Michigan Technological University": "mtu4u@mtu.edu",
    "Mid America Christian University": "admissions@macu.edu",
    "Mid Atlantic Christian University": "admissions@macuniversity.edu",
    "Midamerica Nazarene University": "admissions@mnu.edu",
    "Middle Georgia State University": "admissions@mga.edu",
    "Middle Tennessee State University": "admissions@mtsu.edu",
    "Middlebury College": "admissions@middlebury.edu",
    "Midland University": "admissions@midlandu.edu",
    "Midway University": "admissions@midway.edu",
    "Midwestern State University": "admissions@mwsu.edu",
    "Miles College": "admissions@miles.edu",
    "Millersville University": "admissions@millersville.edu",
    "Milligan College": "admissions@milligan.edu",
    "Millikin University": "admis@millikin.edu",
    "Mills College": "admission@mills.edu",
    "Millsaps College": "admissions@millsaps.edu",
    "Milwaukee Institute Of Art And Design": "admissions@miad.edu",
    "Milwaukee School Engineering": "explore@msoe.edu",
    "Minerva Schools Kgi": "admissions@minerva.kgi.edu",
    "Minneapolis College Of Art And Design": "admissions@mcad.edu",
    "Minnesota State University Mankato": "admissions@mnsu.edu",
    "Minnesota State University Moorhead": "admissions@mnstate.edu",
    "Minot State University": "askmsu@minotstateu.edu",
    "Misericordia University": "admiss@misericordia.edu",
    "Mississippi College": "admissions@mc.edu",
    "Mississippi State University": "admit@msstate.edu",
    "Mississippi University For Women": "admissions@muw.edu",
    "Mississippi Valley State University": "admsn@mvsu.edu",
    "Missouri Baptist University": "admissions@mobap.edu",
    "Missouri Southern State University": "admissions@mssu.edu",
    "Missouri State University": "info@missouristate.edu",
    "Missouri University Science And Technology": "admissions@mst.edu",
    "Missouri Valley College": "admissions@moval.edu",
    "Missouri Western State University": "admissions@missouriwestern.edu",
    "Mitchell College": "admissions@mitchell.edu",
    "Molloy College": "admissions@molloy.edu",
    "Monash University": "scenquiries@monash.edu",
    "Monmouth College Il": "admissions@monmouthcollege.edu",
    "Monmouth University": "admission@monmouth.edu",
    "Montana State University Billings": "admissions@msubillings.edu",
    "Montana State University Bozeman": "admissions@montana.edu",
    "Montana State University Northern": "admissions@msun.edu",
    "Montana Tech": "enrollment@mtech.edu",
    "Montclair State University": "msuadm@montclair.edu",
    "Montreat College": "admissions@montreat.edu",
    "Montserrat College Art": "admissions@montserrat.edu",
    "Moravian College": "admissions@moravian.edu",
    "Morehead State University": "admissions@moreheadstate.edu",
    "Morehouse College": "admissions@morehouse.edu",
    "Morgan State University": "admissions@morgan.edu",
    "Morningside College": "admissions@morningside.edu",
    "Morris College": "dcalhoun@morris.edu",
    "Mount Aloysius College": "admissions@mtaloy.edu",
    "Mount Carmel College Of Nursing": "mccnadmissions@mccn.edu",
    "Mount Holyoke College": "admission@mtholyoke.edu",
    "Mount Marty College": "mmcadmit@mtmc.edu",
    "Mount Mary University": "mmu-admiss@mtmary.edu",
    "Mount Mercy University": "admission@mtmercy.edu",
    "Mount Saint Mary College": "admissions@msmc.edu",
    "Mount Saint Marys University": "admissions@msmu.edu",
    "Mount St Joseph University": "admission@msj.edu",
    "Mount St Marys University": "admissions@msmary.edu",
    "Mount Vernon Nazarene University": "admissions@mvnu.edu",
    "Muhlenberg College": "admissions@muhlenberg.edu",
    "Multnomah University": "admiss@multnomah.edu",
    "Murray State University": "msu.admissions@murraystate.edu",
    "Muskingum University": "adminfo@muskingum.edu",
    "Naropa University": "admissions@naropa.edu",
    "National Louis University": "admissions@nl.edu",
    "Navarra University Of": "admision@unav.es",
    "Nazarene Bible College": "info@nbc.edu",
    "Nazareth College": "admissions@naz.edu",
    "Nebraska Christian College": "admissions@nechristian.edu",
    "Nebraska Methodist College": "admissions@methodistcollege.edu",
    "Nebraska Wesleyan University": "admissions@nebrwesleyan.edu",
    "Neumann University": "neumann@neumann.edu",
    "Neumont College Of Computer Science": "admissions@neumont.edu",
    "Nevada State College": "admissions@nsc.edu",
    "New College Florida": "admissions@ncf.edu",
    "New England College": "admission@nec.edu",
    "New England Conservatory Of Music": "admission@necmusic.edu",
    "New England Institute Technology": "admissions@neit.edu",
    "New Hampshire Institute Art": "admissions@nhia.edu",
    "New Hope Christian College": "admissions@newhope.edu",
    "New Jersey City University": "admissions@njcu.edu",
    "New Jersey Institute Technology": "admissions@njit.edu",
    "New Mexico Highlands University": "admission@nmhu.edu",
    "New Mexico Institute Of Mining And Technology": "admission@nmt.edu",
    "New Mexico State University": "admissions@nmsu.edu",
    "New School": "admission@newschool.edu",
    "New School Of Architecture And Design": "bcharbonneau@newschoolarch.edu",
    "New York Institute Technology Nyit": "admissions@nyit.edu",
    "New York School Of Interior Design": "admissions@nysid.edu",
    "New York University": "admissions@nyu.edu",
    "Newberry College": "admissions@newberry.edu",
    "Newbury College": "admissions@newbury.edu",
    "Newcastle University": "americas.io@ncl.ac.uk",
    "Newman University": "admissions@newmanu.edu",
    "Niagara University": "admissions@niagara.edu",
    "Nicholls State University": "nicholls@nicholls.edu",
    "Nichols College": "admissions@nichols.edu",
    "Norfolk State University": "admissions@nsu.edu",
    "North Carolina Central University": "admissions@nccu.edu",
    "North Carolina State University": "undergrad-admissions@ncsu.edu",
    "North Carolina Wesleyan College": "adm@ncwc.edu",
    "North Central College": "admissions@noctrl.edu",
    "North Central University": "admissions@northcentral.edu",
    "North Dakota State University": "ndsu.admission@ndsu.edu",
    "North Greenville University": "admissions @ngu.edu",
    "North Park University": "admissions@northpark.edu",
    "Northeastern Illinois University": "admrec@neiu.edu",
    "Northeastern State University": "nsuinfo@nsuok.edu",
    "Northern Arizona University": "admissions@nau.edu",
    "Northern Illinois University": "admissions@niu.edu",
    "Northern Kentucky University": "beanorse@nku.edu",
    "Northern Michigan University": "admissions@nmu.edu",
    "Northern State University": "admissions@northern.edu",
    "Northern Vermont University": "Admissions@NorthernVermont.edu",
    "Northern Vermont University Johnson Campus": "jscadmissions@jsc.edu",
    "Northland College": "admit@northland.edu",
    "Northwest Christian University": "admissions@nwcu.edu",
    "Northwest Missouri State University": "admissions@nwmissouri.edu",
    "Northwest Nazarene University": "admissions@nnu.edu",
    "Northwest University": "admissions@northwestu.edu",
    "Northwestern College": "admissions @nwciowa.edu",
    "Northwestern Oklahoma State University": "recruit@nwosu.edu",
    "Northwestern State University Of Louisiana": "applications@nsula.edu",
    "Northwestern University": "ug-admission@northwestern.edu",
    "Northwestern University Qatar": "admissions@qatar.northwestern.edu",
    "Northwood University": "admit@northwood.edu",
    "Northwood University Michigan Campus": "miadmit@northwood.edu",
    "Norwich University": "nuadm@norwich.edu",
    "Notre Dame De Namur University": "admiss@ndnu.edu",
    "Notre Dame Of Maryland University": "admiss@ndm.edu",
    "Nova Scotia College Of Art And Design": "admissions@nscad.ca",
    "Nova Southeastern University": "admissions@nova.edu",
    "Nyack College": "admissions@nyack.edu",
    "Oak Hills Christian College": "admissions@oakhills.edu",
    "Oakland City University": "admission@oak.edu",
    "Oakland University": "visit@oakland.edu",
    "Oakwood University": "admission@oakwood.edu",
    "Oberlin College Arts And Sciences": "college.admissions@oberlin.edu",
    "Oberlin Conservatory Music": "conservatory.admissions@oberlin.edu",
    "Occidental College": "admission@oxy.edu",
    "Oglethorpe University": "admission@oglethorpe.edu",
    "Ohio Dominican University": "admissions@ohiodominican.edu",
    "Ohio Northern University": "admissions-ug@onu.edu",
    "Ohio University": "admissions@ohio.edu",
    "Ohio Valley University": "admissions@ovu.edu",
    "Ohio Wesleyan University": "owuadmit@owu.edu",
    "Oklahoma Baptist University": "admissions@okbu.edu",
    "Oklahoma Christian University": "admissions@oc.edu",
    "Oklahoma City University": "admissions@okcu.edu",
    "Oklahoma Panhandle State University": "opsu@opsu.edu",
    "Oklahoma State University": "admissions@okstate.edu",
    "Oklahoma Wesleyan University": "admissions@okwu.edu",
    "Old Dominion University": "admissions@odu.edu",
    "Ole Miss University Mississippi": "admissions@olemiss.edu",
    "Olivet College": "admissions@olivetcollege.edu",
    "Olivet Nazarene University": "admissions@olivet.edu",
    "Oral Roberts University": "admissions@oru.edu",
    "Oregon College Of Art And Craft": "admissions@ocac.edu",
    "Oregon Institute Of Technology": "oit@oit.edu",
    "Oregon State University": "osuadmit@oregonstate.edu",
    "Otis College Art And Design": "admissions@otis.edu",
    "Ottawa University": "admiss@ottawa.edu",
    "Otterbein University": "uotterb@otterbein.edu",
    "Ouachita Baptist University": "admissions@obu.edu",
    "Our Lady Of The Lake University": "admission@ollusa.edu",
    "Pace University": "appprocessing@pace.edu",
    "Pacific Lutheran University": "admission@plu.edu",
    "Pacific Northwest College Of Art": "admissions@pnca.edu",
    "Pacific Oaks College": "admissions@pacificoaks.edu",
    "Pacific Union College": "admissions@puc.edu",
    "Pacific University Oregon": "admissions@pacificu.edu",
    "Paier College Of Art": "paier.admission@snet.net",
    "Paine College": "admissions@paine.edu",
    "Palm Beach Atlantic University": "admit@pba.edu",
    "Park University": "parkvilleadmissions@park.edu",
    "Parsons The New School For Design": "thinkparsons@newschool.edu",
    "Patrick Henry College": "admissions@phc.edu",
    "Paul Quinn College": "apply@pqc.edu",
    "Paul Smiths College": "admissions@paulsmiths.edu",
    "Peirce College": "admissions@peirce.edu",
    "Penn State": "admissions@psu.edu",
    "Pennsylvania Academy Fine Arts": "admissions@pafa.edu",
    "Pennsylvania College Of Technology": "admissions@pct.edu",
    "Pennsylvania State Erie The Behrend College": "behrend.admissions@psu.edu",
    "Pennsylvania State University Abington": "abingtonadmissions@psu.edu",
    "Pennsylvania State University Altoona": "aaadmit@psu.edu",
    "Pennsylvania State University Beaver": "br-admissions@psu.edu",
    "Pennsylvania State University Berks": "berksadmissions@psu.edu",
    "Pennsylvania State University Brandywine": "bwadmissions@psu.edu",
    "Pennsylvania State University Dubois Campus": "kcn3@psu.edu",
    "Pennsylvania State University Fayette": "feadm@psu.edu",
    "Pennsylvania State University Greater Allegheny": "psuga@psu.edu",
    "Pennsylvania State University Harrisburg": "hbgadmit@psu.edu",
    "Pennsylvania State University Hazleton": "hn-admissions@psu.edu",
    "Pennsylvania State University Lehigh Valley": "admissions-lv@psu.edu",
    "Pennsylvania State University Mont Alto": "psuma@psu.edu",
    "Pennsylvania State University New Kensington": "nkadmissions@psu.edu",
    "Pennsylvania State University Schuylkill": "sl-admissions@psu.edu",
    "Pennsylvania State University Shenango": "psushenango@psu.edu",
    "Pennsylvania State University Wilkes Barre Campus": "wbadmissions@psu.edu",
    "Pennsylvania State University Worthington Scranton": "wsadmissions@psu.edu",
    "Pennsylvania State University York": "ykadmission@psu.edu",
    "Pepperdine University": "admission-seaver@pepperdine.edu",
    "Peru State College": "admissions@peru.edu",
    "Pfeiffer University": "admissions@pfeiffer.edu",
    "Philander Smith College": "admissions@philander.edu",
    "Piedmont College": "ugrad@piedmont.edu",
    "Piedmont International University": "admissions@piedmontu.edu",
    "Pine Manor College": "admissions@pmc.edu",
    "Pittsburg State University": "psuadmit@pittstate.edu",
    "Pitzer College": "admission@pitzer.edu",
    "Plymouth State University": "admissions@plymouth.edu",
    "Point Loma Nazarene University": "admissions@pointloma.edu",
    "Point Park University": "enroll@pointpark.edu",
    "Point University": "admissions@point.edu",
    "Polk State College": "studentservices@polk.edu",
    "Polytechnic University Of Puerto Rico": "tcardona@pupr.edu",
    "Pomona College": "admissions@pomona.edu",
    "Pontifical Catholic University Of Puerto Rico Ponce": "admisiones@pucpr.edu",
    "Pontifical College Josephinum": "admissions@pcj.edu",
    "Portland State University": "admissions@pdx.edu",
    "Potomac University Of The": "admissions@potomac.edu",
    "Prairie View Am University": "admissions@pvamu.edu",
    "Pratt Institute": "admissions@pratt.edu",
    "Presbyterian College": "admissions@presby.edu",
    "Prescott College": "admissions@prescott.edu",
    "Presentation College": "admit@presentation.edu",
    "Princeton University": "uaoffice@princeton.edu",
    "Principia College": "collegeadmissions@principia.edu",
    "Providence College": "pcadmiss@providence.edu",
    "Purdue University Fort Wayne": "ask@pfw.edu",
    "Purdue University Northwest": "admissions@pnw.edu",
    "Queens University Canada": "admission@queensu.ca",
    "Queens University Charlotte": "admissions@queens.edu",
    "Quest University Canada": "admissions@questu.ca",
    "Quincy University": "admissions@quincy.edu",
    "Quinnipiac University": "admissions@qu.edu",
    "Radford University": "admissions@radford.edu",
    "Ramapo College New Jersey": "admissions@ramapo.edu",
    "Randolph College": "admissions@randolphcollege.edu",
    "Randolph Macon College": "admissions@rmc.edu",
    "Reed College": "admission@reed.edu",
    "Regent University": "admissions@regent.edu",
    "Regents University London": "admit@regents.ac.uk",
    "Regis College": "admission@regiscollege.edu",
    "Regis University": "ruadmissions@regis.edu",
    "Reinhardt University": "admissions@reinhardt.edu",
    "Rensselaer Polytechnic Institute": "admissions@rpi.edu",
    "Research College Of Nursing": "leslie.burry@researchcollege.edu",
    "Resurrection University": "admissions@resu.edu",
    "Rhode Island College": "admissions@ric.edu",
    "Rhode Island School Design": "admissions@risd.edu",
    "Rhodes College": "dataservices@rhodes.edu",
    "Rhodes College	": "adminfo@rhodes.edu",
    "Rice University": "admi@rice.edu",
    "Richmond American International University London": "usadmissions@richmond.ac.uk",
    "Rider University": "admissions@rider.edu",
    "Riga Business School": "info@rbs.lv",
    "Ringling College Art And Design": "admissions@ringling.edu",
    "Ripon College": "adminfo@ripon.edu",
    "Ritsumeikan Asia Pacific University": "welcome@apu.ac.jp",
    "Rivier University": "admissions@rivier.edu",
    "Roanoke College": "admissions@roanoke.edu",
    "Robert Gordon University": "UGOffice@rgu.ac.uk",
    "Robert Morris University": "enroll@robertmorris.edu",
    "Robert Morris University Pa": "admissions@rmu.edu",
    "Roberts Wesleyan College": "admissions@roberts.edu",
    "Rochester College": "admissions@rc.edu",
    "Rochester Institute Technology": "admissions@rit.edu",
    "Rockford University": "admissions@rockford.edu",
    "Rockhurst University": "admissions@rockhurst.edu",
    "Rocky Mountain College": "admissions@rocky.edu",
    "Rocky Mountain College Of Art And Design": "admissions@rmcad.edu",
    "Roger Williams University": "admit@rwu.edu",
    "Rogers State University": "admissions@rsu.edu",
    "Rollins College": "admission@rollins.edu",
    "Roosevelt University": "admission@roosevelt.edu",
    "Rose Hulman Institute Technology": "admissions@rose-hulman.edu",
    "Rosemont College": "admissions@rosemont.edu",
    "Rowan University": "admissions@rowan.edu",
    "Rush University": "rmc_admissions@rush.edu",
    "Rust College": "admissions @rustcollege.edu",
    "Rutgers The State University Of New Jersey Camden": "admissions@camden.rutgers.edu",
    "Rutgers The State University Of New Jersey New Brunswick": "admissions@ugadm.rutgers.edu",
    "Rutgers The State University Of New Jersey Newark": "newark@admissions.rutgers.edu",
    "Ryerson University": "international@ryerson.ca",
    "Sacred Heart Major Seminary": "admissions@shms.edu",
    "Sacred Heart University": "enroll@sacredheart.edu",
    "Sage Colleges": "contact@sage.edu",
    "Saginaw Valley State University": "admissions @svsu.edu",
    "Sagu American Indian College": "aicinfo @sagu.edu",
    "Saint Anselm College": "admission@anselm.edu",
    "Saint Augustines University": "admissions @st-aug.edu",
    "Saint Francis University": "admissions@francis.edu",
    "Saint Josephs College Maine": "admissions@sjcme.edu",
    "Saint Josephs University": "admit@sju.edu",
    "Saint Leo University": "admissions@saintleo.edu",
    "Saint Louis University": "admission@slu.edu",
    "Saint Louis University Madrid Campus Spain": "admissions-madrid@slu.edu",
    "Saint Martins University": "admissions@stmartin.edu",
    "Saint Mary Woods College": "admission @smwc.edu",
    "Saint Marys College": "admission@saintmarys.edu",
    "Saint Marys College California": "smcadmit@stmarys-ca.edu",
    "Saint Marys University Minnesota": "admission@smumn.edu",
    "Saint Michaels College": "admission@smcvt.edu",
    "Saint Peters University": "admissions @saintpeters.edu",
    "Saint Vincent College": "admission@stvincent.edu",
    "Saint Xavier University": "admission@sxu.edu",
    "Salem College": "admissions@salem.edu",
    "Salem State University": "admissions@salemstate.edu",
    "Salisbury University": "admissions@salisbury.edu",
    "Salve Regina University": "sruadmis@salve.edu",
    "Sam Houston State University": "admissions@shsu.edu",
    "Samford University": "admission@samford.edu",
    "San Diego Christian College": "admissions@sdcc.edu",
    "San Diego State University": "admissions@sdsu.edu",
    "San Francisco Art Institute": "admissions@sfai.edu",
    "San Francisco Conservatory Of Music": "admit@sfcm.edu",
    "San Francisco State University": "ugadmit@sfsu.edu",
    "San Jose State University": "admissions@sjsu.edu",
    "Santa Clara University": "admission@scu.edu",
    "Sarah Lawrence College": "slcadmit@sarahlawrence.edu",
    "Savannah College Art And Design": "admission@scad.edu",
    "Savannah State University": "admissions@savannahstate.edu",
    "School Art Institute Chicago": "admiss@saic.edu",
    "School Of The Museum Of Fine Arts Boston": "smfaadmissions@tufts.edu",
    "School Of Visual Arts": "admissions@sva.edu",
    "Schreiner University": "admissions@schreiner.edu",
    "Scripps College": "admission@scrippscollege.edu",
    "Seattle Pacific University": "admissions@spu.edu",
    "Seattle University": "admissions@seattleu.edu",
    "Seton Hall University": "thehall@shu.edu",
    "Seton Hill University": "admit@setonhill.edu",
    "Sewanee": "admiss@sewanee.edu",
    "Shasta Bible College And Graduate School": "admissions@shasta.edu",
    "Shaw University": "admissions@shawu.edu",
    "Shawnee State University": "to_ssu@shawnee.edu",
    "Shenandoah University": "admit@su.edu",
    "Shepherd University": "admission@shepherd.edu",
    "Shippensburg University Of Pennsylvania": "admiss@ship.edu",
    "Shorter University": "admissions@shorter.edu",
    "Siena College": "admissions@siena.edu",
    "Siena Heights University": "admissions@sienaheights.edu",
    "Sierra Nevada College": "admissions@sierranevada.edu",
    "Silver Lake College": "admslc@sl.edu",
    "Simmons University": "ugadm@simmons.edu",
    "Simon Fraser University": "admissionsteam@sfu.ca",
    "Simpson College": "admiss@simpson.edu",
    "Simpson University": "admissions@simpsonu.edu",
    "Skidmore College": "admissions@skidmore.edu",
    "Slippery Rock University Of Pennsylvania": "asktherock@sru.edu",
    "Smith College": "admission@smith.edu",
    "Soka University of America": "admission@soka.edu",
    "Sonoma State University": "student.outreach@sonoma.edu",
    "South Carolina State University": "admissions@scsu.edu",
    "South Dakota School Of Mines And Technology": "admissions@sdsmt.edu",
    "South Dakota State University": "sdsu.admissions@sdstate.edu",
    "Southeast Missouri State University": "admissions@semo.edu",
    "Southeastern Baptist Theological Seminary": "admissions@sebts.edu",
    "Southeastern Louisiana University": "admissions@southeastern.edu",
    "Southeastern Oklahoma State University": "admissions@se.edu",
    "Southeastern University": "admission@seu.edu",
    "Southern Adventist University": "admissions@southern.edu",
    "Southern Arkansas University": "muleriders@saumag.edu",
    "Southern California Institute of Architecture": "admissions@sciarc.edu",
    "Southern Connecticut State University": "admissions@southernct.edu",
    "Southern Illinois University Carbondale": "admissions@siu.edu",
    "Southern Illinois University Edwardsville": "admissions@siue.edu",
    "Southern Methodist University": "ugadmission@smu.edu",
    "Southern Nazarene University": "admissions@snu.edu",
    "Southern New Hampshire University": "admission@snhu.edu",
    "Southern Oregon University": "admissions@sou.edu",
    "Southern University And Am College": "admit@subr.edu",
    "Southern University At New Orleans": "lgarrett@suno.edu",
    "Southern Utah University": "adminfo@suu.edu",
    "Southern Vermont College": "admissions@svc.edu",
    "Southern Virginia University": "admissions@svu.edu",
    "Southern Wesleyan University": "admissions@swu.edu",
    "Southwest Baptist University": "admissions@sbuniv.edu",
    "Southwest Minnesota State University": "smsu.admissions@smsu.edu",
    "Southwest University Of Visual Arts": "admissions@suva.edu",
    "Southwestern Adventist University": "admissions@swau.edu",
    "Southwestern Assemblies Of God University": "admissions@sagu.edu",
    "Southwestern Christian University": "admissions@swcu.edu",
    "Southwestern College": "scadmit@sckans.edu",
    "Southwestern Oklahoma State University": "admissions@swosu.edu",
    "Southwestern University": "admission@southwestern.edu",
    "Spalding University": "admissions@spalding.edu",
    "Spelman College": "admissions@spelman.edu",
    "Spring Arbor University": "admissions@arbor.edu",
    "Spring Hill College": "admit@shc.edu",
    "Springfield College": "admissions@springfieldcollege.edu",
    "St Ambrose University": "admit@sau.edu",
    "St Andrews University": "admissions@sa.edu",
    "St Anthony College Of Nursing": "admissions@sacn.edu",
    "St Bonaventure University": "admissions@sbu.edu",
    "St Catherine University": "admissions@stkate.edu",
    "St Cloud State University": "scsu4u@stcloudstate.edu",
    "St Edwards University": "seu.admit@stedwards.edu",
    "St Francis College": "admissions@sfc.edu",
    "St Francis Medical Center College Of Nursing": "conadmissions@osfhealthcare.org",
    "St John Fisher College": "admissions@sjfc.edu",
    "St Johns College Annapolis": "annapolis.admissions@sjc.edu",
    "St Johns College SantaFe": "santafe.admissions@sjc.edu",
    "St Johns College Md": "admissions@sjc.edu",
    "St Johns University": "admhelp@stjohns.edu",
    "St Josephs College Brooklyn": "brooklynas@sjcny.edu",
    "St Josephs College Brooklyn Campus": "bkadmissions@sjcny.edu",
    "St Josephs College Long Island Campus": "liadmissions@sjcny.edu",
    "St Josephs College New York Long Island": "longislandas@sjcny.edu",
    "St Lawrence University": "admissions@stlawu.edu",
    "St Louis Christian College": "admissions@stlchristian.edu",
    "St Louis College Pharmacy": "admissions@stlcop.edu",
    "St Mary University Twickenham London": "admit@stmarys.ac.uk",
    "St Marys College": "admissions@smcm.edu",
    "St Marys University Of San Antonio": "uadm@stmarytx.edu",
    "St Norbert College": "admit@snc.edu",
    "St Olaf College": "admissions@stolaf.edu",
    "St Petersburg College": "information@spcollege.edu",
    "St Thomas Aquinas College": "admissions@stac.edu",
    "St Thomas University FL": "signup@stu.edu",
    "St Thomas University Canada": "admissions@stu.ca",
    "Stanford University": "admission@stanford.edu",
    "Stephen F Austin State University": "admissions@sfasu.edu",
    "Stephens College KS": "apply@stephens.edu",
    "Sterling College VT": "admission@sterlingcollege.edu",
    "Sterling College": "admissions@sterling.edu",
    "Stetson University": "admissions@stetson.edu",
    "Stevens Institute Technology": "admissions@stevens.edu",
    "Stevenson University": "admissions@stevenson.edu",
    "Stillman College": "admissions@stillman.edu",
    "Stockton University": "admissions@stockton.edu",
    "Stonehill College": "admission@stonehill.edu",
    "Suffolk University": "admission@suffolk.edu",
    "Sul Ross State University": "admissions@sulross.edu",
    "Sungkyunkwan University": "undergrad@skku.edu",
    "Suny Alfred State College": "admissions@alfredstate.edu",
    "Suny Binghamton University": "admit@binghamton.edu",
    "Suny Buffalo State College": "admissions@buffalostate.edu",
    "Suny Cobleskill": "admissions@cobleskill.edu",
    "Suny College Brockport": "admit@brockport.edu",
    "Suny College Environmental Science Forestry": "esfinfo@esf.edu",
    "Suny College Geneseo": "admissions@geneseo.edu",
    "Suny College Old Westbury": "enroll@oldwestbury.edu",
    "Suny College Oneonta": "admissions@oneonta.edu",
    "Suny College Technology Canton": "admissions@canton.edu",
    "Suny Cortland": "admissions@cortland.edu",
    "Suny Delhi": "enroll@delhi.edu",
    "Suny Empire State College": "admissions@esc.edu",
    "Suny Farmingdale State College": "admissions@farmingdale.edu",
    "Suny Fredonia": "admissions@fredonia.edu",
    "Suny Korea": "admission@sunykorea.ac.kr",
    "Suny Maritime College": "admissions@sunymaritime.edu",
    "Suny Morrisville State College": "admissions@morrisville.edu",
    "Suny New Paltz": "admissions@newpaltz.edu",
    "Suny Oswego": "admiss@oswego.edu",
    "Suny Plattsburgh": "admissions@plattsburgh.edu",
    "Suny Polytechnic Institute": "admissions@sunyit.edu",
    "Suny Potsdam": "admissions@potsdam.edu",
    "Suny Purchase College": "admissions@purchase.edu",
    "Suny Stony Brook University": "enroll@stonybrook.edu",
    "Suny University Albany": "ugadmissions@albany.edu",
    "Suny University Buffalo": "ub-admissions@buffalo.edu",
    "Susquehanna University": "suadmiss@susqu.edu",
    "Swarthmore College": "admissions@swarthmore.edu",
    "Sweet Briar College": "admissions@sbc.edu",
    "Syracuse University": "orange@syr.edu",
    "Tabor College": "admissions@tabor.edu",
    "Talladega College": "admissions@talladega.edu",
    "Tarleton State University": "uadm@tarleton.edu",
    "Taylor University": "admissions@taylor.edu",
    "Temple University": "tuadm@temple.edu",
    "Temple University Japan Campus": "ac@tuj.temple.edu",
    "Tennessee State University": "admissions@tnstate.edu",
    "Tennessee Technological University": "admissions@tntech.edu",
    "Tennessee Wesleyan University": "admissions@tnwesleyan.edu",
    "Texas Am International University": "adms@tamiu.edu",
    "Texas Am University College Station": "admissions@tamu.edu",
    "Texas Am University Commerce": "admissions@tamuc.edu",
    "Texas Am University Corpus Christi": "admiss@tamucc.edu",
    "Texas Am University Kingsville": "admissions@tamuk.edu",
    "Texas Am University Texarkana": "admissions@tamut.edu",
    "Texas Christian University": "frogmail@tcu.edu",
    "Texas College": "admissions@texascollege.edu",
    "Texas Lutheran University": "admissions@tlu.edu",
    "Texas Southern University": "admissions@tsu.edu",
    "Texas State University": "admissions@txstate.edu",
    "Texas Tech University": "admissions@ttu.edu",
    "Texas University Of The Rio Grande Valley": "admissions@utrgv.edu",
    "Texas Wesleyan University": "admissions@txwes.edu",
    "Texas Womans University": "admissions@twu.edu",
    "The American College Of Greece": "admissions@acg.edu",
    "The American University In Cairo": "enrolauc@aucegypt.edu",
    "The Boston Conservatory": "conservatoryadmissions@berklee.edu",
    "The Citadel": "admissions@citadel.edu",
    "The College Of Idaho": "admissions@collegeofidaho.edu",
    "The College Of St Rose": "admit@mail.strose.edu",
    "The Kings College": "admissions@tkc.edu",
    "The Masters University And Seminary": "admissions@masters.edu",
    "The New School College Of Performing Arts": "performingarts@newschool.edu",
    "The Sage Colleges": "admission@sage.edu",
    "The University Of Alabama": "admissions@ua.edu",
    "The University Of Alabama Huntsville": "uahadmissions@uah.edu",
    "The University Of British Columbia": "admissions.inquiry@ubc.ca",
    "The University Of Montana": "admiss@umontana.edu",
    "The University Of Montana Western": "admissions@umwestern.edu",
    "The University Of Mount Olive": "admissions@umo.edu",
    "The University Of New Mexico": "apply@unm.edu",
    "The University Of Texas Of The Permian Basin": "admissions@utpb.edu",
    "The University Of The Arts	admissions": "@uarts.edu",
    "The University Of Utah": "admissions@utah.edu",
    "Thiel College": "admissions@thiel.edu",
    "Thomas Aquinas College": "admissions@thomasaquinas.edu",
    "Thomas College": "admiss@thomas.edu",
    "Thomas Edison State University": "admissions@tesu.edu",
    "Thomas More College": "admissions@thomasmore.edu",
    "Thomas University": "rgagliano@thomasu.edu",
    "Tiffin University": "admiss@tiffin.edu",
    "Toccoa Falls College": "admissions@tfc.edu",
    "Tougaloo College": "admissions@tougaloo.edu",
    "Touro College": "lasadmit@adminm.touro.edu",
    "Towson University": "admissions@towson.edu",
    "Transylvania University": "admissions@transy.edu",
    "Trevecca Nazarene University": "admissions_und@trevecca.edu",
    "Trine University": "admit@trine.edu",
    "Trinity Baptist College": "admissions@tbc.edu",
    "Trinity Christian College": "admissions@trnty.edu",
    "Trinity College": "admissions.office@trincoll.edu",
    "Trinity College Of Florida": "admissions@trinitycollege.edu",
    "Trinity College Of Nursing Health Sciences": "lori.perez@trinitycollegeqc.edu",
    "Trinity International University": "admissions@tiu.edu",
    "Trinity University": "admissions@trinity.edu",
    "Trinity Washington University": "admissions@trinitydc.edu",
    "Troy University": "admit@troy.edu",
    "Truett Mcconnell University": "admissions@truett.edu",
    "Truman State University": "admissions@truman.edu",
    "Tufts University": "undergraduate.admissions@tufts.edu",
    "Tulane University": "undergrad.admission@tulane.edu",
    "Tusculum College": "admissions@tusculum.edu",
    "Tusculum University": "admission@tusculum.edu",
    "Tuskegee University": "admissions@mytu.tuskegee.edu",
    "Underwood International College Yonsei University": "uicadm@yonsei.ac.kr",
    "Union College NY": "admissions@union.edu",
    "Union College KY": "enrollme@unionky.edu",
    "Union College NE": "ucenroll@ucollege.edu",
    "Union Institute University": "admissions@myunion.edu",
    "Union University": "info@uu.edu",
    "United States Air Force Academy": "rr_webmail@usafa.edu",
    "United States Coast Guard Academy": "admissions@uscga.edu",
    "United States Merchant Marine Academy": "admissions@usmma.edu",
    "United States Military Academy": "admissions-info@usma.edu",
    "United States Naval Academy": "inquire@usna.edu",
    "Unity College": "admissions@unity.edu",
    "Universidad Adventista De Las Antillas": "admissions@uaa.edu",
    "Universidad Carlos Iii De Madrid": "prospectivestudents@uc3m.es",
    "Universidad Del Este Une": "ue_rfuentes@suagm.edu",
    "Universidad Del Sagrado Corazon": "kcastillo@sagrado.edu",
    "Universidad Del Turabo": "admisiones-ut@suagm.edu",
    "University Of Aberdeen": "sras@abdn.ac.uk",
    "University Of Advancing Technology": "admissions@uat.edu",
    "University Of Akron Main Campus": "admissions@uakron.edu",
    "University Of Alabama Birmingham Uab": "chooseuab@uab.edu",
    "University Of Alaska Anchorage": "admissions@alaska.edu",
    "University Of Alaska Fairbanks": "admissions @uaf.edu",
    "University Of Alaska Southeast": "admissions@uas.alaska.edu",
    "University Of Alberta": "ian.reade@ualberta.ca",
    "University Of Arizona": "admissions@arizona.edu",
    "University Of Arkansas": "uofa@uark.edu",
    "University Of Arkansas At Fort Smith": "admissions@uafs.edu",
    "University Of Arkansas At Little Rock": "admissions@ualr.edu",
    "University Of Arkansas At Monticello": "admissions@uamont.edu",
    "University Of Arkansas At Pine Bluff": "owasoyop@uapb.edu",
    "University Of Baltimore": "admissions@ubalt.edu",
    "University Of Bridgeport": "admit@bridgeport.edu",
    "University Of Bristol": "choose-bristol@bristol.ac.uk",
    "University Of Calgary": "future.students@ucalgary.ca",
    "University Of California At Merced": "admissions@ucmerced.edu",
    "University Of California Davis": "undergraduateadmissions@ucdavis.edu",
    "University Of California Irvine": "admissions@uci.edu",
    "University Of California Riverside": "admissions@ucr.edu",
    "University Of California Santa Barbara": "admissions@sa.ucsb.edu",
    "University Of California Santa Cruz": "admissions@ucsc.edu",
    "University Of Central Arkansas": "admissions@uca.edu",
    "University Of Central Florida": "admissions@ucf.edu",
    "University Of Central Missouri": "admit@ucmo.edu",
    "University Of Central Oklahoma": "onestop@uco.edu",
    "University Of Charleston": "admissions@ucwv.edu",
    "University Of Chicago": "collegeadmissions@uchicago.edu",
    "University Of Cincinnati": "admissions@uc.edu",
    "University Of Cincinnati Blue Ash College And Clermont College": "admissions@ucblueash.edu",
    "University Of Cincinnati Clermont College": "clermont.admissions@uc.edu",
    "University Of College Dublin": "northamerica@ucd.ie",
    "University Of Colorado Boulder": "admissions@colorado.edu",
    "University Of Colorado Colorado Springs": "go@uccs.edu",
    "University Of Colorado Denver": "admissions@ucdenver.edu",
    "University Of Connecticut": "beahusky@uconn.edu",
    "University Of Dallas": "ugadmis@udallas.edu",
    "University Of Dayton": "admission@udayton.edu",
    "University Of Delaware": "admissions@udel.edu",
    "University Of Denver": "admission@du.edu",
    "University Of Detroit Mercy": "admissions@udmercy.edu",
    "University Of Dubuque": "admssns@dbq.edu",
    "University Of East Anglia": "admissions@uea.ac.uk",
    "University Of East London": "americas@uel.ac.uk",
    "University Of Evansville": "admission@evansville.edu",
    "University Of Findlay": "admissions@findlay.edu",
    "University Of Florida": "webrequests@admissions.ufl.edu",
    "University Of Georgia": "adm-info@uga.edu",
    "University Of Glasgow": "student.recruitment@glasgow.ac.uk",
    "University Of Guam": "admitme@triton.uog.edu",
    "University Of Guelph": "intapps@uoguelph.ca",
    "University Of Hartford": "admission @hartford.edu",
    "University Of Hawaii At Hilo": "uhhadm@hawaii.edu",
    "University Of Hawaii At Manoa": "manoa.admissions@hawaii.edu",
    "University Of Hawaii West Oahu": "uhwo.admissions@hawaii.edu",
    "University Of Holy Cross": "admissions@uhcno.edu",
    "University Of Hong Kong": "admissions@hku.hk",
    "University Of Houston": "admissions@uh.edu",
    "University Of Houston Clear Lake": "admissions@uhcl.edu",
    "University Of Houston Downtown": "uhdadmit@uhd.edu",
    "University Of Houston Victoria": "admissions@uhv.edu",
    "University Of Huddersfield": "international.office@hud.ac.uk",
    "University Of Idaho": "admissions@uidaho.edu",
    "University Of Illinois At Chicago": "admit@uic.edu",
    "University Of Illinois Chicago": "admissions@uic.edu",
    "University Of Illinois Springfield": "admissions@uis.edu",
    "University Of Indianapolis": "admissions@uindy.edu",
    "University Of Iowa": "admissions@uiowa.edu",
    "University Of Jamestown": "admissions@uj.edu",
    "University Of Kansas": "admissions@ku.edu",
    "University Of Kentucky": "admissions@uky.edu",
    "University Of La Verne": "admission@laverne.edu",
    "University Of Lethbridge": "admissions@uleth.ca",
    "University Of Limerick": "international@ul.ie",
    "University Of Lincoln": "intadmissions@lincoln.ac.uk",
    "University Of Louisiana At Lafayette": "admissions@louisiana.edu",
    "University Of Louisiana At Monroe": "admissions@ulm.edu",
    "University Of Louisville": "admitme@louisville.edu",
    "University Of Lynchburg": "admissions@lynchburg.edu",
    "University Of Maine": "umaineadmissions@maine.edu",
    "University Of Maine At Augusta": "umaadm@maine.edu",
    "University Of Maine Augusta": "umaadmin@maine.edu",
    "University Of Maine Farmington": "umfadmit@maine.edu",
    "University Of Maine Fort Kent": "umfkadm@maine.edu",
    "University Of Maine Machias": "ummadmissions@maine.edu",
    "University Of Maine Presque Isle": "admissions@maine.edu",
    "University Of Mary": "enroll@umary.edu",
    "University Of Mary Hardin Baylor": "admission@umhb.edu",
    "University Of Mary Washington": "admit@umw.edu",
    "University Of Maryland Baltimore County": "admissions@umbc.edu",
    "University Of Maryland Eastern Shore": "umesadmissions@umes.edu",
    "University Of Maryland University College": "admissions@umuc.edu",
    "University Of Massachusetts Boston": "undergrad.admissions@umb.edu",
    "University Of Massachusetts Dartmouth": "admissions@umassd.edu",
    "University Of Massachusetts Lowell": "admissions@uml.edu",
    "University Of Memphis": "recruitment@memphis.edu",
    "University Of Miami": "admission@miami.edu",
    "University Of Michigan Dearborn": "umd-admissions@umich.edu",
    "University Of Michigan Flint": "admissions@umflint.edu",
    "University Of Michigan Shanghai Jiao Tong University Of Joint Institute": "ji-intadm@sjtu.edu.cn",
    "University Of Minnesota At Crookston": "umcinfo@umn.edu",
    "University Of Minnesota Duluth": "umdadmis@d.umn.edu",
    "University Of Minnesota Morris": "admissions@morris.umn.edu",
    "University Of Minnesota Rochester": "applyumr@r.umn.edu",
    "University Of Minnesota Twin Cities": "admissions@umn.edu",
    "University Of Missouri": "askmizzou@missouri.edu",
    "University Of Missouri Columbia": "mu4u@missouri.edu",
    "University Of Missouri Kansas City": "admit@umkc.edu",
    "University Of Missouri St Louis": "admissions@umsl.edu",
    "University Of Mobile": "umenrollment@umobile.edu",
    "University Of Montevallo": "admissions@montevallo.edu",
    "University Of Mount Union": "admission@mountunion.edu",
    "University Of Nebraska Kearney": "admissionsug@unk.edu",
    "University Of Nebraska Lincoln": "admissions@unl.edu",
    "University Of Nebraska Omaha": "unoadmissions@unomaha.edu",
    "University Of Nevada Las Vegas Unlv": "admissions@unlv.edu",
    "University Of Nevada Reno": "asknevada@unr.edu",
    "University Of New England": "admissions@une.edu",
    "University Of New Hampshire": "admissions@unh.edu",
    "University Of New Haven": "admissions@newhaven.edu",
    "University Of New Orleans": "admission@uno.edu",
    "University Of North Alabama": "admissions@una.edu",
    "University Of North Carolina Asheville": "admissions@unca.edu",
    "University Of North Carolina At Pembroke": "admissions@uncp.edu",
    "University Of North Carolina Chapel Hill": "unchelp@admissions.unc.edu",
    "University Of North Carolina Charlotte": "admissions@uncc.edu",
    "University Of North Carolina Greensboro": "admissions@uncg.edu",
    "University Of North Carolina School Of The Arts": "admissions@uncsa.edu",
    "University Of North Carolina Wilmington": "admissions@uncw.edu",
    "University Of North Dakota": "admissions@und.edu",
    "University Of North Florida": "admissions@unf.edu",
    "University Of North Georgia": "admissions-dah@ung.edu",
    "University Of North Texas": "unt.freshman@unt.edu",
    "University Of Northern Colorado": "admissions@unco.edu",
    "University Of Northern Iowa": "admissions@uni.edu",
    "University Of Northwestern St Paul": "admissions@unwsp.edu",
    "University Of Notre Dame": "admissions@nd.edu",
    "University Of Oklahoma": "admissions@ou.edu",
    "University Of Oregon": "uoadmit@uoregon.edu",
    "University Of Pacific": "admission@pacific.edu",
    "University Of Pennsylvania": "info@admissions.upenn.edu",
    "University Of Pikeville": "wewantyou@upike.edu",
    "University Of Pittsburgh": "oafa@pitt.edu",
    "University Of Pittsburgh At Bradford": "nazemetz@pitt.edu",
    "University Of Pittsburgh At Greensburg": "upgadmit@pitt.edu",
    "University Of Pittsburgh At Johnstown": "upjadmit@pitt.edu",
    "University Of Plymouth": "international-admissions@plymouth.ac.uk",
    "University Of Portland": "admissions@up.edu",
    "University Of Providence": "admissions@uprovidence.edu",
    "University Of Puerto Rico Arecibo": "admisiones.arecibo@upr.edu",
    "University Of Puerto Rico Bayamon": "admisiones.bayamon@upr.edu",
    "University Of Puerto Rico Ponce": "emily.matos@upr.edu",
    "University Of Puget Sound": "admission@pugetsound.edu",
    "University Of Redlands": "admissions@redlands.edu",
    "University Of Rhode Island": "admission@uri.edu",
    "University Of Richmond": "admission@richmond.edu",
    "University Of Rio Grande": "admissions@rio.edu",
    "University Of Rochester": "admit@admissions.rochester.edu",
    "University Of Saint Francis Fort Wayne Indiana": "admis@sf.edu",
    "University Of Saint Joseph": "admissions@usj.edu",
    "University Of San Diego": "admissions@sandiego.edu",
    "University Of San Francisco": "admissions@usfca.edu",
    "University Of Saskatchewan": "admissions@usask.ca",
    "University Of Science And Arts Of Oklahoma": "usao-admissions@usao.edu",
    "University Of Sciences": "admit@usciences.edu",
    "University Of Scranton": "admissions@scranton.edu",
    "University Of Sheffield": "shefapply@sheffield.ac.uk",
    "University Of Sioux Falls": "admissions@usiouxfalls.edu",
    "University Of South Alabama": "admiss@southalabama.edu",
    "University Of South Carolina Aiken": "admit@usca.edu",
    "University Of South Carolina Beaufort": "admissions@uscb.edu",
    "University Of South Carolina Columbia": "admissions-ugrad@sc.edu",
    "University Of South Carolina Upstate": "admissions@uscupstate.edu",
    "University Of South Dakota": "admissions@usd.edu",
    "University Of South Florida": "admissions@usf.edu",
    "University Of South Florida Sarasota Manatee": "admissions@sar.usf.edu",
    "University Of Southern Indiana": "enroll@usi.edu",
    "University Of Southern Maine": "admitusm@maine.edu",
    "University Of Southern Mississippi": "admissions@usm.edu",
    "University Of St Andrews": "myapplication@st-andrews.ac.uk",
    "University Of St Francis Il": "admissions@stfrancis.edu",
    "University Of St Mary": "admiss@stmary.edu",
    "University Of St Thomas": "admissions@stthom.edu",
    "University Of St Thomas Mn": "admissions@stthomas.edu",
    "University Of Stirling": "admissions@stir.ac.uk",
    "University Of Tampa": "admissions@ut.edu",
    "University Of Tennessee At Chattanooga": "utcmocs@utc.edu",
    "University Of Tennessee At Martin": "admitme@utm.edu",
    "University Of Tennessee Knoxville": "admissions@utk.edu",
    "University Of Texas At Arlington": "admissions@uta.edu",
    "University Of Texas At Dallas": "interest@utdallas.edu",
    "University Of Texas At El Paso": "futureminer@utep.edu ",
    "University Of Texas At San Antonio": "prospects@utsa.edu",
    "University Of Texas At Tyler": "admissions@uttyler.edu",
    "University Of The Cumberlands": "admiss@ucumberlands.edu",
    "University Of The District Of Columbia": "udcadmissions@udc.edu",
    "University Of The Incarnate Word": "admis@uiwtx.edu",
    "University Of The Ozarks": "admiss@ozarks.edu",
    "University Of The Pacific": "admissions@pacific.edu",
    "University Of The Southwest": "admission@usw.edu",
    "University Of The Virgin Islands": "admissions@uvi.edu",
    "University Of Toledo": "enroll@utoledo.edu",
    "University Of Toronto": "admissions.help@utoronto.ca",
    "University Of Tulsa": "admission@utulsa.edu",
    "University Of Vermont": "admissions@uvm.edu",
    "University Of Virginia": "undergradadmission@virginia.edu",
    "University Of Virginias College Wise": "admissions@uvawise.edu",
    "University Of Warwick": "ugadmissions@warwick.ac.uk",
    "University Of Washington Bothell": "uwbinfo@uw.edu",
    "University Of Washington Tacoma": "uwtinfo@uw.edu",
    "University Of West": "admission@uwest.edu",
    "University Of West Alabama": "admissions@uwa.edu",
    "University Of West Florida": "admissions@uwf.edu",
    "University Of West Georgia": "admiss@westga.edu",
    "University Of West London": "international@uwl.ac.uk",
    "University Of Windsor": "admissions@uwindsor.ca",
    "University Of Wisconsin Eau Claire": "admissions@uwec.edu",
    "University Of Wisconsin Green Bay": "admissions@uwgb.edu",
    "University Of Wisconsin La Crosse": "admissions@uwlax.edu",
    "University Of Wisconsin Milwaukee": "uwmlook@uwm.edu",
    "University Of Wisconsin Oshkosh": "admissions@uwosh.edu",
    "University Of Wisconsin Parkside": "admissions@uwp.edu",
    "University Of Wisconsin Platteville": "admit@uwplatt.edu",
    "University Of Wisconsin River Falls": "admissions@uwrf.edu",
    "University Of Wisconsin Stevens Point": "admiss@uwsp.edu",
    "University Of Wisconsin Stout": "admissions@uwstout.edu",
    "University Of Wisconsin Superior": "admissions@uwsuper.edu",
    "University Of Wisconsin Whitewater": "uwwadmit@uww.edu",
    "University Of Wyoming": "admissions@uwyo.edu",
    "University Worcester Uk": "international@worc.ac.uk",
    "Upper Iowa University": "ADMISSION@uiu.edu",
    "Urbana University ": "admissions@urbana.edu",
    "Ursinus College": "admission@ursinus.edu",
    "Ursuline College": "admission@ursuline.edu",
    "Utah State University": "admit@usu.edu",
    "Utah Valley University": "admissions@uvu.edu",
    "Utica College": "admiss@utica.edu",
    "Valdosta State University": "admissions@valdosta.edu",
    "Valley City State University": "enrollment.services@vcsu.edu",
    "Valparaiso University": "undergrad.admission@valpo.edu",
    "Vanderbilt University": "admissions@vanderbilt.edu",
    "Vandercook College Of Music": "admissions@vandercook.edu",
    "Vanguard University Of Southern California": "admissions@vanguard.edu",
    "Vassar College": "admissions@vassar.edu",
    "Vaughn College Of Aeronautics And Technology": "admitme@vaughn.edu",
    "Vermont Technical College": "admissions@vtc.edu",
    "Villanova University": "gotovu@villanova.edu",
    "Virginia Commonwealth University": "ugrad@vcu.edu",
    "Virginia Military Institute": "admissions@vmi.edu",
    "Virginia Polytechnic Institute And State University": "admissions@vt.edu",
    "Virginia State University": "admiss@vsu.edu",
    "Virginia Union University": "admissions@vuu.edu",
    "Virginia University Of Lynchburg": "admissions@vul.edu",
    "Virginia Wesleyan University": "admissions@vwu.edu",
    "Viterbo University": "admission@viterbo.edu",
    "Voorhees College": "admissions@voorhees.edu",
    "Wabash College": "admissions@wabash.edu",
    "Wagner College": "admissions@wagner.edu",
    "Wake Forest University": "admissions@wfu.edu",
    "Waldorf University": "admissions@waldorf.edu",
    "Walla Walla University": "admiss1@wallawalla.edu",
    "Walsh University": "admissions@walsh.edu",
    "Warner Pacific University": "admissions@warnerpacific.edu",
    "Warner University": "admissions@warner.edu",
    "Warren Wilson College": "admit@warren-wilson.edu",
    "Wartburg College": "admissions@wartburg.edu",
    "Warwick University Of The": "northamerica@warwick.ac.uk",
    "Washburn University": "admissions@washburn.edu",
    "Washington Adventist University": "enroll@wau.edu",
    "Washington And Lee University": "admissions@wlu.edu",
    "Washington College": "wc_admissions@washcoll.edu",
    "Washington Jefferson College": "admission@washjeff.edu",
    "Washington State University": "admissions@wsu.edu",
    "Washington University of St Louis": "admissions@wustl.edu",
    "Watkins College Art Design Film": "admissions@watkins.edu",
    "Wayland Baptist University": "admityou@wbu.edu",
    "Wayne State College": "admit1@wsc.edu",
    "Wayne State University": "admissions@wayne.edu",
    "Waynesburg University": "admissions@waynesburg.edu",
    "Webb Institute": "admissions@webb.edu",
    "Webber International University": "admissions@webber.edu",
    "Weber State University": "admissions@weber.edu",
    "Webster University": "admit@webster.edu",
    "Welch College": "recruit@welch.edu",
    "Wellesley College": "admissions@wellesley.edu",
    "Wells College": "admissions@wells.edu",
    "Wentworth Institute Technology": "admissions@wit.edu",
    "Wesley College": "admissions@wesley.edu",
    "Wesleyan College": "admissions@wesleyancollege.edu",
    "Wesleyan University": "admission@wesleyan.edu",
    "West Chester University": "ugadmiss@wcupa.edu",
    "West Liberty University": "admissions@westliberty.edu",
    "West Texas Am University": "admissions@wtamu.edu",
    "West Virginia State University": "admissions@wvstateu.edu",
    "West Virginia University": "wvuadmissions@mail.wvu.edu",
    "West Virginia University Institute Of Technology": "tech-admissions@mail.wvu.edu",
    "West Virginia University Parkersburg": "admissions@wvup.edu",
    "West Virginia Wesleyan College": "admissions@wvwc.edu",
    "Western Carolina University": "admiss@wcu.edu",
    "Western Connecticut State University": "admissions@wcsu.edu",
    "Western Illinois University": "admissions@wiu.edu",
    "Western Kentucky University": "admission@wku.edu",
    "Western Michigan University": "ask-wmu@wmich.edu",
    "Western New England University": "cwystepe@wne.edu",
    "Western New Mexico University": "admissions@wnmu.edu",
    "Western Oregon University": "worlfgram@wou.edu",
    "Western State Colorado University": "admissions@western.edu",
    "Western University": "reg-admissions@uwo.ca",
    "Western Washington University": "admit@wwu.edu",
    "Westfield State University": "admissions@westfield.ma.edu",
    "Westminster College": "admi@westminster.edu",
    "Westminster College Missouri": "admissions@westminster-mo.edu",
    "Westminster College Utah": "admission@westminstercollege.edu",
    "Westmont College": "admissions@westmont.edu",
    "Wheaton College Il": "admissions@wheaton.edu",
    "Wheaton College Massachusetts": "admission@wheatoncollege.edu",
    "Wheeling Jesuit University": "admiss@wju.edu",
    "Whitman College": "admission@whitman.edu",
    "Whittier College": "admission@whittier.edu",
    "Whitworth University": "admissions@whitworth.edu",
    "Wichita State University": "admissions@wichita.edu",
    "Widener University": "admissions.office@widener.edu",
    "Wilberforce University": "admission@wilberforce.edu",
    "Wilkes Honors College": "hcadmissions@fau.edu",
    "Wilkes University": "admissions@wilkes.edu",
    "Willamette University": "bearcat@willamette.edu",
    "William Carey University": "admissions@wmcarey.edu",
    "William Jessup University": "admissions@jessup.edu",
    "William Jewell College": "admission@william.jewell.edu",
    "William Paterson University Nj": "admissions@wpunj.edu",
    "William Peace University": "admissions@peace.edu",
    "William Penn University": "admissions@wmpenn.edu",
    "William Woods University": "admissions@williamwoods.edu",
    "Williams Baptist College": "admissions@wbcoll.edu",
    "Williams College": "admission@williams.edu",
    "Wilmington College": "admissions@wilmington.edu",
    "Wilmington University": "infocenter@wilmu.edu",
    "Wilson College": "admissions@wilson.edu",
    "Wingate University": "admit@wingate.edu",
    "Winona State University": "admissions@winona.edu",
    "Winston Salem State University": "admissions@wssu.edu",
    "Winthrop University": "admissions@winthrop.edu",
    "Wisconsin Lutheran College": "admissions@wlc.edu",
    "Wittenberg Universit": "admission@wittenberg.edu",
    "Wofford College": "admission@wofford.edu",
    "Woodbury University": "info@woodbury.edu",
    "Worcester Polytechnic Institute": "admissions@wpi.edu",
    "Worcester State University": "admissions@worcester.edu",
    "Wright State University": "admissions@wright.edu",
    "Wright State University Lake Campus": "discoverlakecampus@wright.edu",
    "Wyoming Catholic College": "admissions@wyomingcatholiccollege.com",
    "Xavier University OH": "xuadmit@xavier.edu",
    "Xavier University LA": "admissions@xula.edu",
    "Yale Nus College": "admissions@yale-nus.edu.sg",
    "Yale University": "student.questions@yale.edu",
    "Yeshiva University": "yuadmit@yu.edu",
    "York College PA": "admissions@ycp.edu",
    "York University": "enroll@york.edu",
    "York University Toronto": "intlenq@yorku.ca",
    "Young Harris College": "admissions@yhc.edu",
    "Youngstown State University": "enroll@ysu.edu",
};

const EMAIL_TEMPLATE = "Dear Admissions Office, \n\n  I hope this email finds you well. I am a high school senior currently in the process of researching colleges to apply to. I came across your (***insert major***) Bachelors program on collegeScoreCard, and I am very interested in applying to your institution. As you know, college is a significant financial investment, and I want to make an informed decision before committing to a program. I noticed that the collegeScoreCard does not provide future earnings information for the (***insert major***) Bachelors program at your school. I believe this information would be helpful in making an informed decision about my future. Therefore, I am writing to inquire if your office has any data or resources available that could provide insight into the future earnings potential for graduates of the (***insert major***) Bachelors program at your institution. I am particularly interested in learning more about the median starting salary and potential career paths for graduates of this program. Thank you in advance for your time and consideration.I look forward to hearing back from you soon. Sincerely, __________";

const SUBJECT_TEMPLATE = "Request : Earnings Info for Cyber Security Bachelors Program [Your Name]";

const EmailForm = () => {
    const [selectedEmail, setSelectedEmail] = useState({ name: Object.keys(EMAILS)[0], email: EMAILS[Object.keys(EMAILS)[0]] });
    const [emailBody, setEmailBody] = useState(EMAIL_TEMPLATE);
 
    const sendEmail = () => {
        const subject = SUBJECT_TEMPLATE.replace("[Your Name]", selectedEmail.name);
        const mailtoLink = `mailto:${selectedEmail.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
        window.location.href = mailtoLink;
    };

    const handleEmailChange = event => {
        const selectedEmailName = event.target.value;
        setSelectedEmail({ name: selectedEmailName, email: EMAILS[selectedEmailName] });
    };

    const handleBodyChange = event => {
        setEmailBody(event.target.value);
    };

    return (
        <div>
            <div>
                <label htmlFor="emailSelect">School:</label>
                <select id="emailSelect" value={selectedEmail.name} onChange={handleEmailChange}>
                    {Object.keys(EMAILS).map(name => (
                        <option key={name} value={name}>{name}</option>
                    ))}
                </select>
            </div>
            <div >
                <div> 
                    <label>To: </label> {selectedEmail.email}
                </div>
                <div>
                <label htmlFor="emailBody">Body:</label>
                    <textarea className="emailtext" id="emailBody" value={emailBody} onChange={handleBodyChange} />
                </div>
            </div>
            <button onClick={sendEmail}>Send</button>
        </div> 
    );
};

export default EmailForm;
